// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/config/v1/config.proto" (package "agency.config.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ModelConfig } from "../../model/v1/model";
import { TierConfig } from "../../billing/v1/billing";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { StreamPlacement } from "../../policy/v1/policy";
import { Duration } from "../../../google/protobuf/duration";
import { IdentityConfig } from "./identity_config";
import { PlacementPolicy } from "../../policy/v1/policy";
import { QuotaConfig } from "../../quota/v1/quota";
import { ConsumerPolicy } from "../../policy/v1/policy";
import { StreamPolicy } from "../../policy/v1/policy";
/**
 * HarnessConfig is the root configuration for the harness.
 *
 * @generated from protobuf message agency.config.v1.HarnessConfig
 */
export interface HarnessConfig {
    /**
     * config_path is the root configuration directory.
     *
     * @generated from protobuf field: string config_path = 1
     */
    configPath: string;
    /**
     * nats configures NATS connectivity.
     *
     * @generated from protobuf field: agency.config.v1.NATSConfig nats = 2
     */
    nats?: NATSConfig;
    /**
     * streams defines stream policies by name.
     *
     * @generated from protobuf field: map<string, agency.policy.v1.StreamPolicy> streams = 3
     */
    streams: {
        [key: string]: StreamPolicy;
    };
    /**
     * consumers defines consumer policies by name.
     *
     * @generated from protobuf field: map<string, agency.policy.v1.ConsumerPolicy> consumers = 4
     */
    consumers: {
        [key: string]: ConsumerPolicy;
    };
    /**
     * kv_buckets defines KV bucket configurations by name.
     *
     * @generated from protobuf field: map<string, agency.config.v1.KVBucketConfig> kv_buckets = 5
     */
    kvBuckets: {
        [key: string]: KVBucketConfig;
    };
    /**
     * actors configures actor system behavior.
     *
     * @generated from protobuf field: agency.config.v1.ActorConfig actors = 6
     */
    actors?: ActorConfig;
    /**
     * quota_defaults are default quota settings.
     *
     * @generated from protobuf field: agency.quota.v1.QuotaConfig quota_defaults = 7
     */
    quotaDefaults?: QuotaConfig;
    /**
     * observability configures telemetry and monitoring.
     *
     * @generated from protobuf field: agency.config.v1.ObservabilityConfig observability = 8
     */
    observability?: ObservabilityConfig;
    /**
     * federation configures cross-harness communication.
     *
     * @generated from protobuf field: agency.config.v1.FederationConfig federation = 9
     */
    federation?: FederationConfig;
    /**
     * operations configures operational parameters.
     *
     * @generated from protobuf field: agency.config.v1.OperationsConfig operations = 10
     */
    operations?: OperationsConfig;
    /**
     * billing configures billing aggregation.
     *
     * @generated from protobuf field: agency.config.v1.BillingConfig billing = 11
     */
    billing?: BillingConfig;
    /**
     * security configures security parameters.
     *
     * @generated from protobuf field: agency.config.v1.SecurityConfig security = 12
     */
    security?: SecurityConfig;
    /**
     * placement defines topology and routing.
     *
     * @generated from protobuf field: agency.policy.v1.PlacementPolicy placement = 13
     */
    placement?: PlacementPolicy;
    /**
     * credentials configures credential service.
     *
     * @generated from protobuf field: agency.config.v1.CredentialConfig credentials = 14
     */
    credentials?: CredentialConfig;
    /**
     * identity configures identity and key management.
     *
     * @generated from protobuf field: agency.config.v1.IdentityConfig identity = 15
     */
    identity?: IdentityConfig;
    /**
     * object_stores defines object store policies by name.
     * Referenced by provisioning manifests via object_stores[*].policy.
     * Replaces the inline object_store_policies sections in provisioning YAML files.
     *
     * @generated from protobuf field: map<string, agency.config.v1.ObjectStoreConfig> object_stores = 16
     */
    objectStores: {
        [key: string]: ObjectStoreConfig;
    };
    /**
     * session_spawn_policy controls behavior when session actor not found during dispatch.
     * Values: "error_on_missing" (default), "spawn_on_demand"
     * - error_on_missing: Returns error, message goes to DLQ (current production behavior)
     * - spawn_on_demand: Spawns SessionActor automatically on first ingress message
     *
     * @generated from protobuf field: string session_spawn_policy = 17
     */
    sessionSpawnPolicy: string;
    /**
     * region identifies the geographical or logical deployment region.
     * Used in URN construction for all harness actors and tool instances.
     * Must match the region configured in client/provider config.
     *
     * @generated from protobuf field: string region = 18
     */
    region: string;
    /**
     * context_provider configures the context-provider handler in NATSBridgeActor.
     * Required when context-provider clients are used.
     *
     * @generated from protobuf field: agency.config.v1.ContextProviderConfig context_provider = 19
     */
    contextProvider?: ContextProviderConfig;
}
/**
 * ContextKVConfig holds the shared KV bucket and trigger subject patterns used
 * by context-service, context-bridge, and context-provider.
 * All three must be configured identically — they address the same KV buckets.
 *
 * @generated from protobuf message agency.config.v1.ContextKVConfig
 */
export interface ContextKVConfig {
    /**
     * atom_bucket_pattern is the KV bucket pattern for context atoms (one %s: tenant).
     *
     * @generated from protobuf field: string atom_bucket_pattern = 1
     */
    atomBucketPattern: string;
    /**
     * workspace_config_bucket_pattern is the KV bucket pattern for workspace config
     * (one %s: tenant; keys are prefixed by workspace ID).
     *
     * @generated from protobuf field: string workspace_config_bucket_pattern = 2
     */
    workspaceConfigBucketPattern: string;
    /**
     * trigger_subject_pattern is the NATS subject pattern for ContextBuildTrigger
     * publication (two %s: tenant, workspace).
     *
     * @generated from protobuf field: string trigger_subject_pattern = 3
     */
    triggerSubjectPattern: string;
}
/**
 * ContextProviderConfig configures the context-provider handler in NATSBridgeActor.
 * The harness subscribes to context.atom.<tenant>.<workspace> and proxies operations
 * into JetStream KV on behalf of context-provider clients (core NATS only).
 *
 * @generated from protobuf message agency.config.v1.ContextProviderConfig
 */
export interface ContextProviderConfig {
    /**
     * kv holds the shared KV bucket and trigger subject patterns.
     *
     * @generated from protobuf field: agency.config.v1.ContextKVConfig kv = 1
     */
    kv?: ContextKVConfig;
    /**
     * request_subject_pattern is the NATS subject pattern the harness subscribes to
     * for context-provider req/reply (two %s: tenant, workspace).
     * Example: "context.atom.%s.%s"
     *
     * @generated from protobuf field: string request_subject_pattern = 2
     */
    requestSubjectPattern: string;
}
/**
 * NATSConfig configures NATS connectivity.
 *
 * @generated from protobuf message agency.config.v1.NATSConfig
 */
export interface NATSConfig {
    /**
     * urls are NATS server URLs.
     *
     * @generated from protobuf field: repeated string urls = 1
     */
    urls: string[];
    /**
     * credentials_path is the path to NATS credentials file.
     *
     * @generated from protobuf field: string credentials_path = 2
     */
    credentialsPath: string;
    /**
     * nkey_seed_path is the path to NKey seed file.
     *
     * @generated from protobuf field: string nkey_seed_path = 3
     */
    nkeySeedPath: string;
    /**
     * jwt_path is the path to JWT file.
     *
     * @generated from protobuf field: string jwt_path = 4
     */
    jwtPath: string;
    /**
     * tls_ca_path is the path to the shared TLS CA certificate (SOPS-encrypted).
     * All per-account client certs are signed by this CA.
     *
     * @generated from protobuf field: string tls_ca_path = 7
     */
    tlsCaPath: string;
    /**
     * tls_clients_dir is the base directory for per-account TLS client certificates.
     * Structure: {tls_clients_dir}/{account}/client/cert.pem
     *            {tls_clients_dir}/{account}/client/key.pem
     * Each NATS account (operator, tenants) has its own client TLS identity.
     *
     * @generated from protobuf field: string tls_clients_dir = 13
     */
    tlsClientsDir: string;
    /**
     * tls_ca_key_path is the path to the SOPS-encrypted TLS CA private key.
     * Used to sign client certificate requests during client registration.
     * Format: {"data": "<PEM>"} (same envelope as tls_ca_path).
     *
     * @generated from protobuf field: string tls_ca_key_path = 14
     */
    tlsCaKeyPath: string;
    /**
     * client_nats_urls are the NATS URLs returned to registering clients.
     * Use when the server's own urls are internal (e.g. Docker hostnames) and
     * clients must connect via a different address. Falls back to urls if empty.
     *
     * @generated from protobuf field: repeated string client_nats_urls = 15
     */
    clientNatsUrls: string[];
    /**
     * max_reconnect_attempts is the maximum reconnection attempts.
     *
     * @generated from protobuf field: int32 max_reconnect_attempts = 8
     */
    maxReconnectAttempts: number;
    /**
     * reconnect_wait is the delay between reconnection attempts.
     *
     * @generated from protobuf field: google.protobuf.Duration reconnect_wait = 9
     */
    reconnectWait?: Duration;
    /**
     * ping_interval is the interval between PING messages.
     *
     * @generated from protobuf field: google.protobuf.Duration ping_interval = 10
     */
    pingInterval?: Duration;
    /**
     * max_pings_out is the maximum outstanding PINGs.
     *
     * @generated from protobuf field: int32 max_pings_out = 11
     */
    maxPingsOut: number;
    /**
     * name is the NATS client name.
     *
     * @generated from protobuf field: string name = 12
     */
    name: string;
}
/**
 * KVBucketConfig configures a KV bucket.
 *
 * @generated from protobuf message agency.config.v1.KVBucketConfig
 */
export interface KVBucketConfig {
    /**
     * description is the bucket description.
     *
     * @generated from protobuf field: string description = 1
     */
    description: string;
    /**
     * max_value_size is the maximum value size in bytes.
     *
     * @generated from protobuf field: int32 max_value_size = 2
     */
    maxValueSize: number;
    /**
     * history is the number of historical values to keep.
     *
     * @generated from protobuf field: uint32 history = 3
     */
    history: number;
    /**
     * ttl is the key time-to-live.
     *
     * @generated from protobuf field: google.protobuf.Duration ttl = 4
     */
    ttl?: Duration;
    /**
     * replicas is the number of replicas.
     *
     * @generated from protobuf field: uint32 replicas = 5
     */
    replicas: number;
    /**
     * storage is the storage type (memory/file).
     *
     * @generated from protobuf field: agency.config.v1.StorageType storage = 6
     */
    storage: StorageType;
    /**
     * limit_marker_ttl enables per-key TTLs (jetstream.KeyTTL / Nats-TTL) and sets
     * how long delete/limit markers are kept.
     * Maps to jetstream.KeyValueConfig.LimitMarkerTTL.
     *
     * @generated from protobuf field: google.protobuf.Duration limit_marker_ttl = 7
     */
    limitMarkerTtl?: Duration;
}
/**
 * ObjectStoreConfig configures an object store bucket.
 * Replaces the inline object_store_policies sections in provisioning YAML files.
 *
 * @generated from protobuf message agency.config.v1.ObjectStoreConfig
 */
export interface ObjectStoreConfig {
    /**
     * description is the bucket description.
     *
     * @generated from protobuf field: string description = 1
     */
    description: string;
    /**
     * ttl is the object time-to-live. Zero or absent means no TTL.
     *
     * @generated from protobuf field: google.protobuf.Duration ttl = 2
     */
    ttl?: Duration;
    /**
     * replicas is the number of storage replicas (1–5).
     *
     * @generated from protobuf field: uint32 replicas = 3
     */
    replicas: number;
    /**
     * max_chunk_size is the maximum object chunk size in bytes.
     * Zero uses the NATS default (128 KiB). Advisory only — not enforced at the store level.
     *
     * @generated from protobuf field: int32 max_chunk_size = 4
     */
    maxChunkSize: number;
    /**
     * placement constrains which cluster nodes store this bucket.
     *
     * @generated from protobuf field: agency.policy.v1.StreamPlacement placement = 5
     */
    placement?: StreamPlacement;
}
/**
 * ActorConfig configures actor system behavior.
 *
 * @generated from protobuf message agency.config.v1.ActorConfig
 */
export interface ActorConfig {
    /**
     * context_ready_timeout is the timeout waiting for ContextReady.
     *
     * @generated from protobuf field: google.protobuf.Duration context_ready_timeout = 1
     */
    contextReadyTimeout?: Duration;
    /**
     * hook_timeout is the timeout for hook execution.
     *
     * @generated from protobuf field: google.protobuf.Duration hook_timeout = 2
     */
    hookTimeout?: Duration;
    /**
     * snapshot configures snapshot behavior.
     *
     * @generated from protobuf field: agency.config.v1.SnapshotConfig snapshot = 3
     */
    snapshot?: SnapshotConfig;
    /**
     * tool_dispatch_pool configures the tool execution pool.
     *
     * @generated from protobuf field: agency.config.v1.PoolConfig tool_dispatch_pool = 4
     */
    toolDispatchPool?: PoolConfig;
    /**
     * rate_limit configures ingress rate limiting.
     *
     * @generated from protobuf field: agency.config.v1.RateLimitConfig rate_limit = 5
     */
    rateLimit?: RateLimitConfig;
    /**
     * supervision configures actor supervision.
     *
     * @generated from protobuf field: agency.config.v1.SupervisionConfig supervision = 6
     */
    supervision?: SupervisionConfig;
    /**
     * circuit_breaker configures circuit breaker for external calls.
     *
     * @generated from protobuf field: agency.config.v1.CircuitBreakerConfig circuit_breaker = 7
     */
    circuitBreaker?: CircuitBreakerConfig;
    /**
     * registry_lookup_timeout is the timeout for registry lookups.
     *
     * @generated from protobuf field: google.protobuf.Duration registry_lookup_timeout = 8
     */
    registryLookupTimeout?: Duration;
    /**
     * registry_lookup_retry_delay is the fixed delay between lookup retry attempts.
     *
     * @generated from protobuf field: google.protobuf.Duration registry_lookup_retry_delay = 10
     */
    registryLookupRetryDelay?: Duration;
    /**
     * registry_lookup_max_retries is the maximum number of lookup retry attempts.
     *
     * @generated from protobuf field: int32 registry_lookup_max_retries = 11
     */
    registryLookupMaxRetries: number;
    /**
     * local is ONLY for agency-harness CLI (local development/testing).
     * Production daemon does not use local config.
     *
     * @generated from protobuf field: optional agency.config.v1.LocalConfig local = 9
     */
    local?: LocalConfig;
    /**
     * tool_registry configures the remote tool registry actor (heartbeat + eviction).
     *
     * @generated from protobuf field: agency.config.v1.ToolRegistryConfig tool_registry = 12
     */
    toolRegistry?: ToolRegistryConfig;
    /**
     * hook_registry configures hook descriptor liveness (heartbeat interval for KV TTL refresh).
     *
     * @generated from protobuf field: agency.config.v1.HookRegistryConfig hook_registry = 13
     */
    hookRegistry?: HookRegistryConfig;
}
/**
 * HookRegistryConfig configures hook descriptor liveness tracking via KV TTL refresh.
 *
 * @generated from protobuf message agency.config.v1.HookRegistryConfig
 */
export interface HookRegistryConfig {
    /**
     * heartbeat_interval_seconds is the interval at which providers must re-publish hook
     * descriptors to refresh the KV TTL. Must be less than eviction_ttl_seconds.
     *
     * @generated from protobuf field: int32 heartbeat_interval_seconds = 1
     */
    heartbeatIntervalSeconds: number;
    /**
     * eviction_ttl_seconds is how long after a missed heartbeat before a hook is evicted.
     * Must be greater than heartbeat_interval_seconds.
     *
     * @generated from protobuf field: int32 eviction_ttl_seconds = 2
     */
    evictionTtlSeconds: number;
}
/**
 * ToolRegistryConfig configures remote tool liveness tracking.
 *
 * @generated from protobuf message agency.config.v1.ToolRegistryConfig
 */
export interface ToolRegistryConfig {
    /**
     * heartbeat_interval_seconds is the interval tools must send heartbeats.
     *
     * @generated from protobuf field: int32 heartbeat_interval_seconds = 1
     */
    heartbeatIntervalSeconds: number;
    /**
     * eviction_ttl_seconds is how long after a missed heartbeat before a tool is evicted.
     *
     * @generated from protobuf field: int32 eviction_ttl_seconds = 2
     */
    evictionTtlSeconds: number;
    /**
     * tool_name_duplicate_policy controls behavior when a tool with the same name
     * is already registered in this workspace. Applied at registration time in-memory
     * by RemoteToolRegistryActor. REJECT fails the new registration; EVICT removes
     * the incumbent entry and proceeds.
     *
     * @generated from protobuf field: agency.config.v1.HarnessDuplicatePolicy tool_name_duplicate_policy = 3
     */
    toolNameDuplicatePolicy: HarnessDuplicatePolicy;
}
/**
 * SnapshotConfig configures session snapshotting.
 *
 * @generated from protobuf message agency.config.v1.SnapshotConfig
 */
export interface SnapshotConfig {
    /**
     * interval_steps triggers snapshot every N steps.
     *
     * @generated from protobuf field: int32 interval_steps = 1
     */
    intervalSteps: number;
    /**
     * interval_duration triggers snapshot after duration.
     *
     * @generated from protobuf field: google.protobuf.Duration interval_duration = 2
     */
    intervalDuration?: Duration;
    /**
     * lock_ttl is the snapshot leader election lock TTL.
     *
     * @generated from protobuf field: google.protobuf.Duration lock_ttl = 3
     */
    lockTtl?: Duration;
    /**
     * object_store_threshold is the size threshold for Object Store storage.
     *
     * @generated from protobuf field: int32 object_store_threshold = 4
     */
    objectStoreThreshold: number;
}
/**
 * PoolConfig configures worker pools.
 *
 * @generated from protobuf message agency.config.v1.PoolConfig
 */
export interface PoolConfig {
    /**
     * size is the number of workers.
     *
     * @generated from protobuf field: int32 size = 1
     */
    size: number;
    /**
     * queue_size is the work queue capacity.
     *
     * @generated from protobuf field: int32 queue_size = 2
     */
    queueSize: number;
    /**
     * exclusive_tools are tools requiring single-worker pools.
     *
     * @generated from protobuf field: repeated string exclusive_tools = 3
     */
    exclusiveTools: string[];
}
/**
 * RateLimitConfig configures rate limiting.
 *
 * @generated from protobuf message agency.config.v1.RateLimitConfig
 */
export interface RateLimitConfig {
    /**
     * rps_limit is the requests per second limit.
     *
     * @generated from protobuf field: int32 rps_limit = 1
     */
    rpsLimit: number;
    /**
     * burst is the maximum concurrent in-flight requests.
     *
     * @generated from protobuf field: int32 burst = 2
     */
    burst: number;
    /**
     * per_user_enabled enables per-user rate limiting.
     *
     * @generated from protobuf field: bool per_user_enabled = 3
     */
    perUserEnabled: boolean;
    /**
     * per_tenant_enabled enables per-tenant rate limiting.
     *
     * @generated from protobuf field: bool per_tenant_enabled = 4
     */
    perTenantEnabled: boolean;
}
/**
 * SupervisionConfig configures actor supervision.
 * Hollywood actor system provides fixed-delay restarts only.
 *
 * @generated from protobuf message agency.config.v1.SupervisionConfig
 */
export interface SupervisionConfig {
    /**
     * max_restarts is the maximum restart attempts within window.
     * After exhaustion, HarnessActor publishes HarnessShutdownEvent and initiates graceful shutdown.
     *
     * @generated from protobuf field: int32 max_restarts = 1
     */
    maxRestarts: number;
    /**
     * restart_delay is the fixed delay between restart attempts.
     * Hollywood applies this delay uniformly for all restarts of a child actor.
     *
     * @generated from protobuf field: google.protobuf.Duration restart_delay = 2
     */
    restartDelay?: Duration;
}
/**
 * SupervisorConfig defines supervision strategy for a specific supervisor.
 *
 * @generated from protobuf message agency.config.v1.SupervisorConfig
 */
export interface SupervisorConfig {
    /**
     * strategy defines how to handle child failures.
     *
     * @generated from protobuf field: agency.config.v1.SupervisionStrategy strategy = 1
     */
    strategy: SupervisionStrategy;
    /**
     * max_restarts is the maximum restart attempts for a child.
     *
     * @generated from protobuf field: int32 max_restarts = 2
     */
    maxRestarts: number;
    /**
     * restart_window is the time window for counting restarts.
     *
     * @generated from protobuf field: google.protobuf.Duration restart_window = 3
     */
    restartWindow?: Duration;
    /**
     * backoff_durations are exponential backoff between restarts.
     *
     * @generated from protobuf field: repeated google.protobuf.Duration backoff_durations = 4
     */
    backoffDurations: Duration[];
}
/**
 * CircuitBreakerConfig configures circuit breakers.
 *
 * @generated from protobuf message agency.config.v1.CircuitBreakerConfig
 */
export interface CircuitBreakerConfig {
    /**
     * max_requests is the max requests in half-open state.
     *
     * @generated from protobuf field: uint32 max_requests = 1
     */
    maxRequests: number;
    /**
     * interval is the period for clearing counts.
     *
     * @generated from protobuf field: google.protobuf.Duration interval = 2
     */
    interval?: Duration;
    /**
     * timeout is the open state timeout before half-open.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout = 3
     */
    timeout?: Duration;
    /**
     * consecutive_failures is the threshold for opening.
     *
     * @generated from protobuf field: uint32 consecutive_failures = 4
     */
    consecutiveFailures: number;
}
/**
 * LocalConfig configures local development harness behavior.
 *
 * @generated from protobuf message agency.config.v1.LocalConfig
 */
export interface LocalConfig {
    /**
     * ticker_interval is the demo ticker interval.
     *
     * @generated from protobuf field: google.protobuf.Duration ticker_interval = 1
     */
    tickerInterval?: Duration;
    /**
     * urn_template defines URN components for local demo actors.
     *
     * @generated from protobuf field: agency.config.v1.URNTemplate urn_template = 2
     */
    urnTemplate?: URNTemplate;
}
/**
 * URNTemplate defines components for constructing URNs.
 *
 * @generated from protobuf message agency.config.v1.URNTemplate
 */
export interface URNTemplate {
    /**
     * region is the node region.
     *
     * @generated from protobuf field: string region = 1
     */
    region: string;
    /**
     * kind is the node kind.
     *
     * @generated from protobuf field: string kind = 2
     */
    kind: string;
    /**
     * instance is the node instance identifier.
     *
     * @generated from protobuf field: string instance = 3
     */
    instance: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 4
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 5
     */
    workspace: string;
    /**
     * session is the session identifier.
     *
     * @generated from protobuf field: string session = 6
     */
    session: string;
}
/**
 * ObservabilityConfig configures telemetry.
 *
 * @generated from protobuf message agency.config.v1.ObservabilityConfig
 */
export interface ObservabilityConfig {
    /**
     * otlp_endpoint is the OTLP exporter endpoint.
     *
     * @generated from protobuf field: string otlp_endpoint = 1
     */
    otlpEndpoint: string;
    /**
     * otlp_insecure disables TLS for OTLP.
     *
     * @generated from protobuf field: bool otlp_insecure = 2
     */
    otlpInsecure: boolean;
    /**
     * trace_sampling_rate is the trace sampling probability (0.0-1.0).
     *
     * @generated from protobuf field: float trace_sampling_rate = 3
     */
    traceSamplingRate: number;
    /**
     * metrics_interval is the metrics reporting interval.
     *
     * @generated from protobuf field: google.protobuf.Duration metrics_interval = 4
     */
    metricsInterval?: Duration;
    /**
     * enable_trace_export enables trace export.
     *
     * @generated from protobuf field: bool enable_trace_export = 5
     */
    enableTraceExport: boolean;
    /**
     * enable_metrics_export enables metrics export.
     *
     * @generated from protobuf field: bool enable_metrics_export = 6
     */
    enableMetricsExport: boolean;
}
/**
 * FederationConfig configures cross-harness communication.
 *
 * @generated from protobuf message agency.config.v1.FederationConfig
 */
export interface FederationConfig {
    /**
     * enabled enables federation.
     *
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * harness_id is this harness's unique identifier.
     *
     * @generated from protobuf field: string harness_id = 2
     */
    harnessId: string;
    /**
     * remotes are remote harness configurations.
     *
     * @generated from protobuf field: repeated agency.config.v1.RemoteHarnessConfig remotes = 3
     */
    remotes: RemoteHarnessConfig[];
    /**
     * leafnode_url is the leafnode connection URL.
     *
     * @generated from protobuf field: string leafnode_url = 4
     */
    leafnodeUrl: string;
    /**
     * leafnode_credentials_path is the leafnode credentials path.
     *
     * @generated from protobuf field: string leafnode_credentials_path = 5
     */
    leafnodeCredentialsPath: string;
}
/**
 * RemoteHarnessConfig configures a remote harness.
 *
 * @generated from protobuf message agency.config.v1.RemoteHarnessConfig
 */
export interface RemoteHarnessConfig {
    /**
     * harness_id is the remote harness identifier.
     *
     * @generated from protobuf field: string harness_id = 1
     */
    harnessId: string;
    /**
     * leafnode_url is the remote leafnode URL.
     *
     * @generated from protobuf field: string leafnode_url = 2
     */
    leafnodeUrl: string;
    /**
     * trust_level is the trust level for this remote.
     *
     * @generated from protobuf field: agency.config.v1.TrustLevel trust_level = 3
     */
    trustLevel: TrustLevel;
    /**
     * allowed_tenants restricts federation to specific tenants.
     *
     * @generated from protobuf field: repeated string allowed_tenants = 4
     */
    allowedTenants: string[];
}
/**
 * HarnessClaimConfig controls duplicate harness ID enforcement via a NATS KV lease.
 *
 * The harness atomically claims its ID in the operator-account "harness-claims" KV bucket
 * on startup. A heartbeat goroutine refreshes the claim every heartbeat_interval; if the
 * process dies the key expires after lease_ttl and the slot reopens.
 * On clean shutdown the claim is explicitly deleted.
 *
 * All fields are required — no defaults are applied in code.
 *
 * @generated from protobuf message agency.config.v1.HarnessClaimConfig
 */
export interface HarnessClaimConfig {
    /**
     * duplicate_policy controls what happens when another harness with this ID holds the claim.
     *
     * @generated from protobuf field: agency.config.v1.HarnessDuplicatePolicy duplicate_policy = 1
     */
    duplicatePolicy: HarnessDuplicatePolicy;
    /**
     * lease_ttl is the KV bucket MaxAge. Claims expire after this duration if the heartbeat stops.
     * Must be greater than heartbeat_interval.
     *
     * @generated from protobuf field: google.protobuf.Duration lease_ttl = 2
     */
    leaseTtl?: Duration;
    /**
     * heartbeat_interval is how often the harness refreshes its claim.
     * Must be strictly less than lease_ttl.
     *
     * @generated from protobuf field: google.protobuf.Duration heartbeat_interval = 3
     */
    heartbeatInterval?: Duration;
    /**
     * evict_grace_period is the time to wait after publishing the evict signal before claiming
     * the slot. Used only when duplicate_policy = EVICT; must be configured regardless.
     *
     * @generated from protobuf field: google.protobuf.Duration evict_grace_period = 4
     */
    evictGracePeriod?: Duration;
    /**
     * bucket_replicas is the number of replicas for the "harness-claims" KV bucket.
     *
     * @generated from protobuf field: uint32 bucket_replicas = 5
     */
    bucketReplicas: number;
}
/**
 * OperationsConfig configures operational parameters.
 *
 * @generated from protobuf message agency.config.v1.OperationsConfig
 */
export interface OperationsConfig {
    /**
     * health_probe_addr is the health probe server address.
     *
     * @generated from protobuf field: string health_probe_addr = 1
     */
    healthProbeAddr: string;
    /**
     * drain_timeout is the graceful shutdown timeout.
     *
     * @generated from protobuf field: google.protobuf.Duration drain_timeout = 2
     */
    drainTimeout?: Duration;
    /**
     * dlq_config configures dead letter queue behavior.
     *
     * @generated from protobuf field: agency.config.v1.DLQConfig dlq = 3
     */
    dlq?: DLQConfig;
    /**
     * claim configures harness-claim duplicate-ID enforcement.
     *
     * @generated from protobuf field: agency.config.v1.HarnessClaimConfig claim = 4
     */
    claim?: HarnessClaimConfig;
    /**
     * provider_claim configures harness-mediated provider-claim duplicate-ID enforcement.
     *
     * @generated from protobuf field: agency.config.v1.ProviderClaimConfig provider_claim = 5
     */
    providerClaim?: ProviderClaimConfig;
}
/**
 * ProviderClaimConfig configures harness-mediated provider-claim enforcement.
 *
 * The provider sends a ProviderClaimRequest over core NATS to the harness, which performs
 * all KV operations on the tenant-account "provider-claims_<tenant>" bucket. The provider
 * sends heartbeats; the harness refreshes the KV entry on receipt.
 *
 * evict_grace_period is the time the harness waits after publishing the evict signal to the
 * incumbent before writing the new claim. Used only when the provider's policy = EVICT.
 *
 * @generated from protobuf message agency.config.v1.ProviderClaimConfig
 */
export interface ProviderClaimConfig {
    /**
     * evict_grace_period is the time to wait after publishing the evict signal before claiming
     * the slot. Required regardless of the provider's duplicate_policy setting.
     *
     * @generated from protobuf field: google.protobuf.Duration evict_grace_period = 1
     */
    evictGracePeriod?: Duration;
}
/**
 * DLQConfig configures dead letter queue.
 *
 * @generated from protobuf message agency.config.v1.DLQConfig
 */
export interface DLQConfig {
    /**
     * alert_threshold_count triggers alert after N messages.
     *
     * @generated from protobuf field: int32 alert_threshold_count = 1
     */
    alertThresholdCount: number;
    /**
     * alert_threshold_rate triggers alert at % of throughput.
     *
     * @generated from protobuf field: float alert_threshold_rate = 2
     */
    alertThresholdRate: number;
    /**
     * retention is the DLQ message retention duration.
     *
     * @generated from protobuf field: google.protobuf.Duration retention = 3
     */
    retention?: Duration;
    /**
     * retry_policy defines automatic retry behavior.
     *
     * @generated from protobuf field: agency.config.v1.DLQRetryPolicy retry_policy = 4
     */
    retryPolicy: DLQRetryPolicy;
}
/**
 * DLQRetryRequest requests automatic retry of DLQ messages.
 *
 * @generated from protobuf message agency.config.v1.DLQRetryRequest
 */
export interface DLQRetryRequest {
    /**
     * stream_name is the source stream.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer that sent messages to DLQ.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * max_attempts is the maximum retry attempts.
     *
     * @generated from protobuf field: int32 max_attempts = 3
     */
    maxAttempts: number;
    /**
     * initial_delay is the first retry delay.
     *
     * @generated from protobuf field: google.protobuf.Duration initial_delay = 4
     */
    initialDelay?: Duration;
    /**
     * max_delay is the maximum retry delay.
     *
     * @generated from protobuf field: google.protobuf.Duration max_delay = 5
     */
    maxDelay?: Duration;
    /**
     * backoff_multiplier is the exponential backoff multiplier.
     *
     * @generated from protobuf field: float backoff_multiplier = 6
     */
    backoffMultiplier: number;
}
/**
 * DLQReplayRequest requests manual replay of DLQ messages.
 *
 * @generated from protobuf message agency.config.v1.DLQReplayRequest
 */
export interface DLQReplayRequest {
    /**
     * stream_name is the source stream.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer that sent messages to DLQ.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * message_ids are specific messages to replay (empty = all).
     *
     * @generated from protobuf field: repeated string message_ids = 3
     */
    messageIds: string[];
    /**
     * since_timestamp replays messages after this time (if message_ids empty).
     *
     * @generated from protobuf field: google.protobuf.Timestamp since_timestamp = 4
     */
    sinceTimestamp?: Timestamp;
    /**
     * until_timestamp replays messages before this time (if message_ids empty).
     *
     * @generated from protobuf field: google.protobuf.Timestamp until_timestamp = 5
     */
    untilTimestamp?: Timestamp;
    /**
     * dry_run validates the replay without actually executing it.
     *
     * @generated from protobuf field: bool dry_run = 6
     */
    dryRun: boolean;
}
/**
 * DLQRetryResponse confirms retry/replay operation.
 *
 * @generated from protobuf message agency.config.v1.DLQRetryResponse
 */
export interface DLQRetryResponse {
    /**
     * stream_name is the source stream.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * messages_replayed is the count of messages replayed.
     *
     * @generated from protobuf field: int32 messages_replayed = 3
     */
    messagesReplayed: number;
    /**
     * messages_failed is the count of replay failures.
     *
     * @generated from protobuf field: int32 messages_failed = 4
     */
    messagesFailed: number;
    /**
     * started_at is when the replay started.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 5
     */
    startedAt?: Timestamp;
    /**
     * completed_at is when the replay completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 6
     */
    completedAt?: Timestamp;
    /**
     * dry_run indicates if this was a dry run.
     *
     * @generated from protobuf field: bool dry_run = 7
     */
    dryRun: boolean;
}
/**
 * StreamPolicyFile represents a streams.yaml configuration file.
 *
 * @generated from protobuf message agency.config.v1.StreamPolicyFile
 */
export interface StreamPolicyFile {
    /**
     * version is the config file format version.
     *
     * @generated from protobuf field: string version = 1
     */
    version: string;
    /**
     * streams are the stream policy definitions.
     *
     * @generated from protobuf field: map<string, agency.policy.v1.StreamPolicy> streams = 2
     */
    streams: {
        [key: string]: StreamPolicy;
    };
    /**
     * metadata contains file-level metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ConsumerPolicyFile represents a consumers.yaml configuration file.
 *
 * @generated from protobuf message agency.config.v1.ConsumerPolicyFile
 */
export interface ConsumerPolicyFile {
    /**
     * version is the config file format version.
     *
     * @generated from protobuf field: string version = 1
     */
    version: string;
    /**
     * consumers are the consumer policy definitions.
     *
     * @generated from protobuf field: map<string, agency.policy.v1.ConsumerPolicy> consumers = 2
     */
    consumers: {
        [key: string]: ConsumerPolicy;
    };
    /**
     * metadata contains file-level metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * TierConfigFile represents a tiers.yaml configuration file.
 *
 * @generated from protobuf message agency.config.v1.TierConfigFile
 */
export interface TierConfigFile {
    /**
     * version is the config file format version.
     *
     * @generated from protobuf field: string version = 1
     */
    version: string;
    /**
     * tiers are the tier configuration definitions.
     *
     * @generated from protobuf field: map<string, agency.billing.v1.TierConfig> tiers = 2
     */
    tiers: {
        [key: string]: TierConfig;
    };
    /**
     * metadata contains file-level metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ProviderConfigFile represents a providers.yaml configuration file.
 *
 * @generated from protobuf message agency.config.v1.ProviderConfigFile
 */
export interface ProviderConfigFile {
    /**
     * version is the config file format version.
     *
     * @generated from protobuf field: string version = 1
     */
    version: string;
    /**
     * providers are the model provider configurations.
     *
     * @generated from protobuf field: map<string, agency.model.v1.ModelConfig> providers = 2
     */
    providers: {
        [key: string]: ModelConfig;
    };
    /**
     * metadata contains file-level metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * BillingConfig configures billing aggregation.
 *
 * @generated from protobuf message agency.config.v1.BillingConfig
 */
export interface BillingConfig {
    /**
     * rollup_interval is the usage aggregation interval.
     *
     * @generated from protobuf field: google.protobuf.Duration rollup_interval = 1
     */
    rollupInterval?: Duration;
    /**
     * export_enabled enables billing export.
     *
     * @generated from protobuf field: bool export_enabled = 2
     */
    exportEnabled: boolean;
    /**
     * export_endpoint is the billing export endpoint.
     *
     * @generated from protobuf field: string export_endpoint = 3
     */
    exportEndpoint: string;
    /**
     * export_batch_size is the export batch size.
     *
     * @generated from protobuf field: int32 export_batch_size = 4
     */
    exportBatchSize: number;
}
/**
 * SecurityConfig configures security parameters.
 *
 * @generated from protobuf message agency.config.v1.SecurityConfig
 */
export interface SecurityConfig {
    /**
     * credential_cache_ttl is the credential cache duration.
     *
     * @generated from protobuf field: google.protobuf.Duration credential_cache_ttl = 1
     */
    credentialCacheTtl?: Duration;
    /**
     * credential_retry_backoff are credential re-auth backoff durations.
     *
     * @generated from protobuf field: repeated google.protobuf.Duration credential_retry_backoff = 2
     */
    credentialRetryBackoff: Duration[];
    /**
     * credential_max_retries is the maximum credential retry attempts.
     *
     * @generated from protobuf field: int32 credential_max_retries = 3
     */
    credentialMaxRetries: number;
    /**
     * sops_enabled enables SOPS credential encryption.
     *
     * @generated from protobuf field: bool sops_enabled = 4
     */
    sopsEnabled: boolean;
    /**
     * age_enabled enables AGE E2E encryption.
     *
     * @generated from protobuf field: bool age_enabled = 5
     */
    ageEnabled: boolean;
    /**
     * key_rotation_interval is the key rotation period.
     *
     * @generated from protobuf field: google.protobuf.Duration key_rotation_interval = 6
     */
    keyRotationInterval?: Duration;
    /**
     * require_age_for_edge requires AGE encryption for edge nodes.
     *
     * @generated from protobuf field: bool require_age_for_edge = 7
     */
    requireAgeForEdge: boolean;
    /**
     * client_nats_user_ttl is the TTL for NATS User JWTs issued during client registration.
     *
     * @generated from protobuf field: google.protobuf.Duration client_nats_user_ttl = 8
     */
    clientNatsUserTtl?: Duration;
    /**
     * client_cert_ttl is the validity duration for TLS client certificates issued during registration.
     *
     * @generated from protobuf field: google.protobuf.Duration client_cert_ttl = 9
     */
    clientCertTtl?: Duration;
}
/**
 * CredentialConfig configures credential handling.
 *
 * @generated from protobuf message agency.config.v1.CredentialConfig
 */
export interface CredentialConfig {
    /**
     * provider is the credential provider type.
     *
     * @generated from protobuf field: string provider = 1
     */
    provider: string;
    /**
     * config_path is the provider configuration file path.
     *
     * @generated from protobuf field: string config_path = 2
     */
    configPath: string;
    /**
     * cache_ttl is the cache duration.
     *
     * @generated from protobuf field: google.protobuf.Duration cache_ttl = 3
     */
    cacheTtl?: Duration;
    /**
     * retry_backoff are retry backoff durations.
     *
     * @generated from protobuf field: repeated google.protobuf.Duration retry_backoff = 4
     */
    retryBackoff: Duration[];
    /**
     * max_retries is the maximum retry attempts.
     *
     * @generated from protobuf field: int32 max_retries = 5
     */
    maxRetries: number;
    /**
     * params are provider-specific parameters.
     *
     * @generated from protobuf field: map<string, string> params = 6
     */
    params: {
        [key: string]: string;
    };
    /**
     * circuit_breaker configures circuit breaker for credential fetches.
     *
     * @generated from protobuf field: agency.config.v1.CircuitBreakerConfig circuit_breaker = 7
     */
    circuitBreaker?: CircuitBreakerConfig;
}
/**
 * ConsumerCreateRequest requests creation of a new consumer.
 *
 * @generated from protobuf message agency.config.v1.ConsumerCreateRequest
 */
export interface ConsumerCreateRequest {
    /**
     * stream_name is the target stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the desired consumer name.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * policy is the consumer policy configuration.
     *
     * @generated from protobuf field: agency.policy.v1.ConsumerPolicy policy = 3
     */
    policy?: ConsumerPolicy;
    /**
     * filter_subjects are subjects to filter messages by.
     *
     * @generated from protobuf field: repeated string filter_subjects = 4
     */
    filterSubjects: string[];
    /**
     * durable indicates if this is a durable consumer.
     *
     * @generated from protobuf field: bool durable = 5
     */
    durable: boolean;
    /**
     * description is the consumer description.
     *
     * @generated from protobuf field: string description = 6
     */
    description: string;
    /**
     * metadata contains consumer metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 7
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ConsumerCreateResponse confirms consumer creation.
 *
 * @generated from protobuf message agency.config.v1.ConsumerCreateResponse
 */
export interface ConsumerCreateResponse {
    /**
     * stream_name is the target stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the created consumer name.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * created indicates if the consumer was newly created.
     *
     * @generated from protobuf field: bool created = 3
     */
    created: boolean;
    /**
     * created_at is when the consumer was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
}
/**
 * ConsumerDeleteRequest requests deletion of a consumer.
 *
 * @generated from protobuf message agency.config.v1.ConsumerDeleteRequest
 */
export interface ConsumerDeleteRequest {
    /**
     * stream_name is the target stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer to delete.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
}
/**
 * ConsumerDeleteResponse confirms consumer deletion.
 *
 * @generated from protobuf message agency.config.v1.ConsumerDeleteResponse
 */
export interface ConsumerDeleteResponse {
    /**
     * deleted indicates if the consumer was deleted.
     *
     * @generated from protobuf field: bool deleted = 1
     */
    deleted: boolean;
    /**
     * deleted_at is when the consumer was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 2
     */
    deletedAt?: Timestamp;
}
/**
 * ConsumerInfoRequest requests consumer information.
 *
 * @generated from protobuf message agency.config.v1.ConsumerInfoRequest
 */
export interface ConsumerInfoRequest {
    /**
     * stream_name is the target stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer to query.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
}
/**
 * ConsumerInfoResponse returns consumer information.
 *
 * @generated from protobuf message agency.config.v1.ConsumerInfoResponse
 */
export interface ConsumerInfoResponse {
    /**
     * stream_name is the target stream name.
     *
     * @generated from protobuf field: string stream_name = 1
     */
    streamName: string;
    /**
     * consumer_name is the consumer name.
     *
     * @generated from protobuf field: string consumer_name = 2
     */
    consumerName: string;
    /**
     * policy is the consumer policy configuration.
     *
     * @generated from protobuf field: agency.policy.v1.ConsumerPolicy policy = 3
     */
    policy?: ConsumerPolicy;
    /**
     * num_pending is the number of pending messages.
     *
     * @generated from protobuf field: uint64 num_pending = 4
     */
    numPending: bigint;
    /**
     * num_ack_pending is the number of unacknowledged messages.
     *
     * @generated from protobuf field: uint64 num_ack_pending = 5
     */
    numAckPending: bigint;
    /**
     * num_redelivered is the number of redelivered messages.
     *
     * @generated from protobuf field: uint64 num_redelivered = 6
     */
    numRedelivered: bigint;
    /**
     * num_waiting is the number of pull requests waiting.
     *
     * @generated from protobuf field: uint64 num_waiting = 7
     */
    numWaiting: bigint;
    /**
     * created_at is when the consumer was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
    /**
     * metadata contains consumer metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 9
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * IngressPolicyConfig configures concurrent ingress handling for a workspace.
 * Delivered via ContextBundle.ingress_policy — workspace-scoped, required.
 * Sessions fail-fast at startup if this field is absent.
 *
 * @generated from protobuf message agency.config.v1.IngressPolicyConfig
 */
export interface IngressPolicyConfig {
    /**
     * max_queue_depth is the maximum number of concurrent ingress messages
     * that can be queued while a turn or tool dispatch is active.
     * Exceeding this limit sends the message to DLQ. Must be > 0.
     *
     * @generated from protobuf field: uint32 max_queue_depth = 1
     */
    maxQueueDepth: number;
}
/**
 * StorageType defines storage backend.
 *
 * @generated from protobuf enum agency.config.v1.StorageType
 */
export enum StorageType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: STORAGE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * FILE uses file-based storage.
     *
     * @generated from protobuf enum value: STORAGE_TYPE_FILE = 1;
     */
    FILE = 1,
    /**
     * MEMORY uses memory-based storage.
     *
     * @generated from protobuf enum value: STORAGE_TYPE_MEMORY = 2;
     */
    MEMORY = 2
}
/**
 * SupervisionStrategy defines how supervisors handle child failures.
 *
 * @generated from protobuf enum agency.config.v1.SupervisionStrategy
 */
export enum SupervisionStrategy {
    /**
     * SUPERVISION_STRATEGY_UNSPECIFIED is invalid.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * RESTART_CHILD restarts the failed child.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_RESTART_CHILD = 1;
     */
    RESTART_CHILD = 1,
    /**
     * STOP_CHILD stops the failed child.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_STOP_CHILD = 2;
     */
    STOP_CHILD = 2,
    /**
     * ESCALATE escalates failure to parent supervisor.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_ESCALATE = 3;
     */
    ESCALATE = 3,
    /**
     * RESUME ignores the failure and resumes the child.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_RESUME = 4;
     */
    RESUME = 4
}
/**
 * TrustLevel defines federation trust levels.
 *
 * @generated from protobuf enum agency.config.v1.TrustLevel
 */
export enum TrustLevel {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * UNTRUSTED requires E2E encryption.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_UNTRUSTED = 1;
     */
    UNTRUSTED = 1,
    /**
     * TRUSTED allows plaintext within secure channel.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_TRUSTED = 2;
     */
    TRUSTED = 2,
    /**
     * INTERNAL is for same-organization harnesses.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_INTERNAL = 3;
     */
    INTERNAL = 3
}
/**
 * HarnessDuplicatePolicy controls behavior when a harness with the same ID is already active.
 *
 * @generated from protobuf enum agency.config.v1.HarnessDuplicatePolicy
 */
export enum HarnessDuplicatePolicy {
    /**
     * UNSPECIFIED is the zero value and must not be used.
     *
     * @generated from protobuf enum value: HARNESS_DUPLICATE_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * REJECT fails startup immediately if a claim for this harness ID already exists.
     *
     * @generated from protobuf enum value: HARNESS_DUPLICATE_POLICY_REJECT = 1;
     */
    REJECT = 1,
    /**
     * EVICT signals the incumbent harness to shut down, waits the configured grace period,
     * then claims the slot. The incumbent detects the signal via the evict subject and
     * initiates graceful shutdown; its heartbeat CAS also detects the stolen claim.
     *
     * @generated from protobuf enum value: HARNESS_DUPLICATE_POLICY_EVICT = 2;
     */
    EVICT = 2
}
/**
 * DLQRetryPolicy defines automatic retry behavior for DLQ messages.
 *
 * @generated from protobuf enum agency.config.v1.DLQRetryPolicy
 */
export enum DLQRetryPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: DLQ_RETRY_POLICY_UNSPECIFIED = 0;
     */
    DLQ_RETRY_POLICY_UNSPECIFIED = 0,
    /**
     * NONE disables automatic retries.
     *
     * @generated from protobuf enum value: DLQ_RETRY_POLICY_NONE = 1;
     */
    DLQ_RETRY_POLICY_NONE = 1,
    /**
     * EXPONENTIAL_BACKOFF retries with exponential backoff.
     *
     * @generated from protobuf enum value: DLQ_RETRY_POLICY_EXPONENTIAL_BACKOFF = 2;
     */
    DLQ_RETRY_POLICY_EXPONENTIAL_BACKOFF = 2,
    /**
     * MANUAL_ONLY requires manual replay via admin API.
     *
     * @generated from protobuf enum value: DLQ_RETRY_POLICY_MANUAL_ONLY = 3;
     */
    DLQ_RETRY_POLICY_MANUAL_ONLY = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class HarnessConfig$Type extends MessageType<HarnessConfig> {
    constructor() {
        super("agency.config.v1.HarnessConfig", [
            { no: 1, name: "config_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "nats", kind: "message", T: () => NATSConfig, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "streams", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => StreamPolicy }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 4, name: "consumers", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConsumerPolicy }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 5, name: "kv_buckets", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => KVBucketConfig }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } } } },
            { no: 6, name: "actors", kind: "message", T: () => ActorConfig, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "quota_defaults", kind: "message", T: () => QuotaConfig, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "observability", kind: "message", T: () => ObservabilityConfig, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "federation", kind: "message", T: () => FederationConfig },
            { no: 10, name: "operations", kind: "message", T: () => OperationsConfig, options: { "buf.validate.field": { required: true } } },
            { no: 11, name: "billing", kind: "message", T: () => BillingConfig, options: { "buf.validate.field": { required: true } } },
            { no: 12, name: "security", kind: "message", T: () => SecurityConfig, options: { "buf.validate.field": { required: true } } },
            { no: 13, name: "placement", kind: "message", T: () => PlacementPolicy },
            { no: 14, name: "credentials", kind: "message", T: () => CredentialConfig },
            { no: 15, name: "identity", kind: "message", T: () => IdentityConfig },
            { no: 16, name: "object_stores", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ObjectStoreConfig }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9._-]*[a-z0-9]$" } } } } } },
            { no: 17, name: "session_spawn_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { in: ["error_on_missing", "spawn_on_demand"] } } } },
            { no: 18, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 19, name: "context_provider", kind: "message", T: () => ContextProviderConfig }
        ]);
    }
    create(value?: PartialMessage<HarnessConfig>): HarnessConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.configPath = "";
        message.streams = {};
        message.consumers = {};
        message.kvBuckets = {};
        message.objectStores = {};
        message.sessionSpawnPolicy = "";
        message.region = "";
        if (value !== undefined)
            reflectionMergePartial<HarnessConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HarnessConfig): HarnessConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string config_path */ 1:
                    message.configPath = reader.string();
                    break;
                case /* agency.config.v1.NATSConfig nats */ 2:
                    message.nats = NATSConfig.internalBinaryRead(reader, reader.uint32(), options, message.nats);
                    break;
                case /* map<string, agency.policy.v1.StreamPolicy> streams */ 3:
                    this.binaryReadMap3(message.streams, reader, options);
                    break;
                case /* map<string, agency.policy.v1.ConsumerPolicy> consumers */ 4:
                    this.binaryReadMap4(message.consumers, reader, options);
                    break;
                case /* map<string, agency.config.v1.KVBucketConfig> kv_buckets */ 5:
                    this.binaryReadMap5(message.kvBuckets, reader, options);
                    break;
                case /* agency.config.v1.ActorConfig actors */ 6:
                    message.actors = ActorConfig.internalBinaryRead(reader, reader.uint32(), options, message.actors);
                    break;
                case /* agency.quota.v1.QuotaConfig quota_defaults */ 7:
                    message.quotaDefaults = QuotaConfig.internalBinaryRead(reader, reader.uint32(), options, message.quotaDefaults);
                    break;
                case /* agency.config.v1.ObservabilityConfig observability */ 8:
                    message.observability = ObservabilityConfig.internalBinaryRead(reader, reader.uint32(), options, message.observability);
                    break;
                case /* agency.config.v1.FederationConfig federation */ 9:
                    message.federation = FederationConfig.internalBinaryRead(reader, reader.uint32(), options, message.federation);
                    break;
                case /* agency.config.v1.OperationsConfig operations */ 10:
                    message.operations = OperationsConfig.internalBinaryRead(reader, reader.uint32(), options, message.operations);
                    break;
                case /* agency.config.v1.BillingConfig billing */ 11:
                    message.billing = BillingConfig.internalBinaryRead(reader, reader.uint32(), options, message.billing);
                    break;
                case /* agency.config.v1.SecurityConfig security */ 12:
                    message.security = SecurityConfig.internalBinaryRead(reader, reader.uint32(), options, message.security);
                    break;
                case /* agency.policy.v1.PlacementPolicy placement */ 13:
                    message.placement = PlacementPolicy.internalBinaryRead(reader, reader.uint32(), options, message.placement);
                    break;
                case /* agency.config.v1.CredentialConfig credentials */ 14:
                    message.credentials = CredentialConfig.internalBinaryRead(reader, reader.uint32(), options, message.credentials);
                    break;
                case /* agency.config.v1.IdentityConfig identity */ 15:
                    message.identity = IdentityConfig.internalBinaryRead(reader, reader.uint32(), options, message.identity);
                    break;
                case /* map<string, agency.config.v1.ObjectStoreConfig> object_stores */ 16:
                    this.binaryReadMap16(message.objectStores, reader, options);
                    break;
                case /* string session_spawn_policy */ 17:
                    message.sessionSpawnPolicy = reader.string();
                    break;
                case /* string region */ 18:
                    message.region = reader.string();
                    break;
                case /* agency.config.v1.ContextProviderConfig context_provider */ 19:
                    message.contextProvider = ContextProviderConfig.internalBinaryRead(reader, reader.uint32(), options, message.contextProvider);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: HarnessConfig["streams"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HarnessConfig["streams"] | undefined, val: HarnessConfig["streams"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = StreamPolicy.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.HarnessConfig.streams");
            }
        }
        map[key ?? ""] = val ?? StreamPolicy.create();
    }
    private binaryReadMap4(map: HarnessConfig["consumers"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HarnessConfig["consumers"] | undefined, val: HarnessConfig["consumers"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ConsumerPolicy.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.HarnessConfig.consumers");
            }
        }
        map[key ?? ""] = val ?? ConsumerPolicy.create();
    }
    private binaryReadMap5(map: HarnessConfig["kvBuckets"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HarnessConfig["kvBuckets"] | undefined, val: HarnessConfig["kvBuckets"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = KVBucketConfig.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.HarnessConfig.kv_buckets");
            }
        }
        map[key ?? ""] = val ?? KVBucketConfig.create();
    }
    private binaryReadMap16(map: HarnessConfig["objectStores"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HarnessConfig["objectStores"] | undefined, val: HarnessConfig["objectStores"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ObjectStoreConfig.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.HarnessConfig.object_stores");
            }
        }
        map[key ?? ""] = val ?? ObjectStoreConfig.create();
    }
    internalBinaryWrite(message: HarnessConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string config_path = 1; */
        if (message.configPath !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.configPath);
        /* agency.config.v1.NATSConfig nats = 2; */
        if (message.nats)
            NATSConfig.internalBinaryWrite(message.nats, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, agency.policy.v1.StreamPolicy> streams = 3; */
        for (let k of globalThis.Object.keys(message.streams)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            StreamPolicy.internalBinaryWrite(message.streams[k], writer, options);
            writer.join().join();
        }
        /* map<string, agency.policy.v1.ConsumerPolicy> consumers = 4; */
        for (let k of globalThis.Object.keys(message.consumers)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ConsumerPolicy.internalBinaryWrite(message.consumers[k], writer, options);
            writer.join().join();
        }
        /* map<string, agency.config.v1.KVBucketConfig> kv_buckets = 5; */
        for (let k of globalThis.Object.keys(message.kvBuckets)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            KVBucketConfig.internalBinaryWrite(message.kvBuckets[k], writer, options);
            writer.join().join();
        }
        /* agency.config.v1.ActorConfig actors = 6; */
        if (message.actors)
            ActorConfig.internalBinaryWrite(message.actors, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.quota.v1.QuotaConfig quota_defaults = 7; */
        if (message.quotaDefaults)
            QuotaConfig.internalBinaryWrite(message.quotaDefaults, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.ObservabilityConfig observability = 8; */
        if (message.observability)
            ObservabilityConfig.internalBinaryWrite(message.observability, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.FederationConfig federation = 9; */
        if (message.federation)
            FederationConfig.internalBinaryWrite(message.federation, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.OperationsConfig operations = 10; */
        if (message.operations)
            OperationsConfig.internalBinaryWrite(message.operations, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.BillingConfig billing = 11; */
        if (message.billing)
            BillingConfig.internalBinaryWrite(message.billing, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.SecurityConfig security = 12; */
        if (message.security)
            SecurityConfig.internalBinaryWrite(message.security, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* agency.policy.v1.PlacementPolicy placement = 13; */
        if (message.placement)
            PlacementPolicy.internalBinaryWrite(message.placement, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.CredentialConfig credentials = 14; */
        if (message.credentials)
            CredentialConfig.internalBinaryWrite(message.credentials, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.IdentityConfig identity = 15; */
        if (message.identity)
            IdentityConfig.internalBinaryWrite(message.identity, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* map<string, agency.config.v1.ObjectStoreConfig> object_stores = 16; */
        for (let k of globalThis.Object.keys(message.objectStores)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ObjectStoreConfig.internalBinaryWrite(message.objectStores[k], writer, options);
            writer.join().join();
        }
        /* string session_spawn_policy = 17; */
        if (message.sessionSpawnPolicy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.sessionSpawnPolicy);
        /* string region = 18; */
        if (message.region !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.region);
        /* agency.config.v1.ContextProviderConfig context_provider = 19; */
        if (message.contextProvider)
            ContextProviderConfig.internalBinaryWrite(message.contextProvider, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.HarnessConfig
 */
export const HarnessConfig = new HarnessConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextKVConfig$Type extends MessageType<ContextKVConfig> {
    constructor() {
        super("agency.config.v1.ContextKVConfig", [
            { no: 1, name: "atom_bucket_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "workspace_config_bucket_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "trigger_subject_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextKVConfig>): ContextKVConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.atomBucketPattern = "";
        message.workspaceConfigBucketPattern = "";
        message.triggerSubjectPattern = "";
        if (value !== undefined)
            reflectionMergePartial<ContextKVConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextKVConfig): ContextKVConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string atom_bucket_pattern */ 1:
                    message.atomBucketPattern = reader.string();
                    break;
                case /* string workspace_config_bucket_pattern */ 2:
                    message.workspaceConfigBucketPattern = reader.string();
                    break;
                case /* string trigger_subject_pattern */ 3:
                    message.triggerSubjectPattern = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextKVConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string atom_bucket_pattern = 1; */
        if (message.atomBucketPattern !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.atomBucketPattern);
        /* string workspace_config_bucket_pattern = 2; */
        if (message.workspaceConfigBucketPattern !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspaceConfigBucketPattern);
        /* string trigger_subject_pattern = 3; */
        if (message.triggerSubjectPattern !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.triggerSubjectPattern);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ContextKVConfig
 */
export const ContextKVConfig = new ContextKVConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextProviderConfig$Type extends MessageType<ContextProviderConfig> {
    constructor() {
        super("agency.config.v1.ContextProviderConfig", [
            { no: 1, name: "kv", kind: "message", T: () => ContextKVConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "request_subject_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextProviderConfig>): ContextProviderConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSubjectPattern = "";
        if (value !== undefined)
            reflectionMergePartial<ContextProviderConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextProviderConfig): ContextProviderConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.config.v1.ContextKVConfig kv */ 1:
                    message.kv = ContextKVConfig.internalBinaryRead(reader, reader.uint32(), options, message.kv);
                    break;
                case /* string request_subject_pattern */ 2:
                    message.requestSubjectPattern = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextProviderConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.config.v1.ContextKVConfig kv = 1; */
        if (message.kv)
            ContextKVConfig.internalBinaryWrite(message.kv, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string request_subject_pattern = 2; */
        if (message.requestSubjectPattern !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestSubjectPattern);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ContextProviderConfig
 */
export const ContextProviderConfig = new ContextProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NATSConfig$Type extends MessageType<NATSConfig> {
    constructor() {
        super("agency.config.v1.NATSConfig", [
            { no: 1, name: "urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10", items: { string: { minLen: "1", maxLen: "512" } } } } } },
            { no: 2, name: "credentials_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 3, name: "nkey_seed_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 4, name: "jwt_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 7, name: "tls_ca_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 13, name: "tls_clients_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 14, name: "tls_ca_key_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 15, name: "client_nats_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "512" } } } } } },
            { no: 8, name: "max_reconnect_attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: -1 } } } },
            { no: 9, name: "reconnect_wait", kind: "message", T: () => Duration },
            { no: 10, name: "ping_interval", kind: "message", T: () => Duration },
            { no: 11, name: "max_pings_out", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 12, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<NATSConfig>): NATSConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.urls = [];
        message.credentialsPath = "";
        message.nkeySeedPath = "";
        message.jwtPath = "";
        message.tlsCaPath = "";
        message.tlsClientsDir = "";
        message.tlsCaKeyPath = "";
        message.clientNatsUrls = [];
        message.maxReconnectAttempts = 0;
        message.maxPingsOut = 0;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<NATSConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NATSConfig): NATSConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string urls */ 1:
                    message.urls.push(reader.string());
                    break;
                case /* string credentials_path */ 2:
                    message.credentialsPath = reader.string();
                    break;
                case /* string nkey_seed_path */ 3:
                    message.nkeySeedPath = reader.string();
                    break;
                case /* string jwt_path */ 4:
                    message.jwtPath = reader.string();
                    break;
                case /* string tls_ca_path */ 7:
                    message.tlsCaPath = reader.string();
                    break;
                case /* string tls_clients_dir */ 13:
                    message.tlsClientsDir = reader.string();
                    break;
                case /* string tls_ca_key_path */ 14:
                    message.tlsCaKeyPath = reader.string();
                    break;
                case /* repeated string client_nats_urls */ 15:
                    message.clientNatsUrls.push(reader.string());
                    break;
                case /* int32 max_reconnect_attempts */ 8:
                    message.maxReconnectAttempts = reader.int32();
                    break;
                case /* google.protobuf.Duration reconnect_wait */ 9:
                    message.reconnectWait = Duration.internalBinaryRead(reader, reader.uint32(), options, message.reconnectWait);
                    break;
                case /* google.protobuf.Duration ping_interval */ 10:
                    message.pingInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.pingInterval);
                    break;
                case /* int32 max_pings_out */ 11:
                    message.maxPingsOut = reader.int32();
                    break;
                case /* string name */ 12:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NATSConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string urls = 1; */
        for (let i = 0; i < message.urls.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.urls[i]);
        /* string credentials_path = 2; */
        if (message.credentialsPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.credentialsPath);
        /* string nkey_seed_path = 3; */
        if (message.nkeySeedPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nkeySeedPath);
        /* string jwt_path = 4; */
        if (message.jwtPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.jwtPath);
        /* string tls_ca_path = 7; */
        if (message.tlsCaPath !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.tlsCaPath);
        /* int32 max_reconnect_attempts = 8; */
        if (message.maxReconnectAttempts !== 0)
            writer.tag(8, WireType.Varint).int32(message.maxReconnectAttempts);
        /* google.protobuf.Duration reconnect_wait = 9; */
        if (message.reconnectWait)
            Duration.internalBinaryWrite(message.reconnectWait, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration ping_interval = 10; */
        if (message.pingInterval)
            Duration.internalBinaryWrite(message.pingInterval, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 max_pings_out = 11; */
        if (message.maxPingsOut !== 0)
            writer.tag(11, WireType.Varint).int32(message.maxPingsOut);
        /* string name = 12; */
        if (message.name !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.name);
        /* string tls_clients_dir = 13; */
        if (message.tlsClientsDir !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.tlsClientsDir);
        /* string tls_ca_key_path = 14; */
        if (message.tlsCaKeyPath !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.tlsCaKeyPath);
        /* repeated string client_nats_urls = 15; */
        for (let i = 0; i < message.clientNatsUrls.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.clientNatsUrls[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.NATSConfig
 */
export const NATSConfig = new NATSConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KVBucketConfig$Type extends MessageType<KVBucketConfig> {
    constructor() {
        super("agency.config.v1.KVBucketConfig", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 2, name: "max_value_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10485760, gte: -1 } } } },
            { no: 3, name: "history", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 64, gte: 1 } } } },
            { no: 4, name: "ttl", kind: "message", T: () => Duration },
            { no: 5, name: "replicas", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 5, gte: 1 } } } },
            { no: 6, name: "storage", kind: "enum", T: () => ["agency.config.v1.StorageType", StorageType, "STORAGE_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 7, name: "limit_marker_ttl", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<KVBucketConfig>): KVBucketConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.description = "";
        message.maxValueSize = 0;
        message.history = 0;
        message.replicas = 0;
        message.storage = 0;
        if (value !== undefined)
            reflectionMergePartial<KVBucketConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KVBucketConfig): KVBucketConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string description */ 1:
                    message.description = reader.string();
                    break;
                case /* int32 max_value_size */ 2:
                    message.maxValueSize = reader.int32();
                    break;
                case /* uint32 history */ 3:
                    message.history = reader.uint32();
                    break;
                case /* google.protobuf.Duration ttl */ 4:
                    message.ttl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.ttl);
                    break;
                case /* uint32 replicas */ 5:
                    message.replicas = reader.uint32();
                    break;
                case /* agency.config.v1.StorageType storage */ 6:
                    message.storage = reader.int32();
                    break;
                case /* google.protobuf.Duration limit_marker_ttl */ 7:
                    message.limitMarkerTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.limitMarkerTtl);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KVBucketConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string description = 1; */
        if (message.description !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.description);
        /* int32 max_value_size = 2; */
        if (message.maxValueSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxValueSize);
        /* uint32 history = 3; */
        if (message.history !== 0)
            writer.tag(3, WireType.Varint).uint32(message.history);
        /* google.protobuf.Duration ttl = 4; */
        if (message.ttl)
            Duration.internalBinaryWrite(message.ttl, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* uint32 replicas = 5; */
        if (message.replicas !== 0)
            writer.tag(5, WireType.Varint).uint32(message.replicas);
        /* agency.config.v1.StorageType storage = 6; */
        if (message.storage !== 0)
            writer.tag(6, WireType.Varint).int32(message.storage);
        /* google.protobuf.Duration limit_marker_ttl = 7; */
        if (message.limitMarkerTtl)
            Duration.internalBinaryWrite(message.limitMarkerTtl, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.KVBucketConfig
 */
export const KVBucketConfig = new KVBucketConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ObjectStoreConfig$Type extends MessageType<ObjectStoreConfig> {
    constructor() {
        super("agency.config.v1.ObjectStoreConfig", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 2, name: "ttl", kind: "message", T: () => Duration },
            { no: 3, name: "replicas", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 5, gte: 1 } } } },
            { no: 4, name: "max_chunk_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "placement", kind: "message", T: () => StreamPlacement }
        ]);
    }
    create(value?: PartialMessage<ObjectStoreConfig>): ObjectStoreConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.description = "";
        message.replicas = 0;
        message.maxChunkSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ObjectStoreConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ObjectStoreConfig): ObjectStoreConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string description */ 1:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration ttl */ 2:
                    message.ttl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.ttl);
                    break;
                case /* uint32 replicas */ 3:
                    message.replicas = reader.uint32();
                    break;
                case /* int32 max_chunk_size */ 4:
                    message.maxChunkSize = reader.int32();
                    break;
                case /* agency.policy.v1.StreamPlacement placement */ 5:
                    message.placement = StreamPlacement.internalBinaryRead(reader, reader.uint32(), options, message.placement);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ObjectStoreConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string description = 1; */
        if (message.description !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration ttl = 2; */
        if (message.ttl)
            Duration.internalBinaryWrite(message.ttl, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 replicas = 3; */
        if (message.replicas !== 0)
            writer.tag(3, WireType.Varint).uint32(message.replicas);
        /* int32 max_chunk_size = 4; */
        if (message.maxChunkSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.maxChunkSize);
        /* agency.policy.v1.StreamPlacement placement = 5; */
        if (message.placement)
            StreamPlacement.internalBinaryWrite(message.placement, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ObjectStoreConfig
 */
export const ObjectStoreConfig = new ObjectStoreConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorConfig$Type extends MessageType<ActorConfig> {
    constructor() {
        super("agency.config.v1.ActorConfig", [
            { no: 1, name: "context_ready_timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "hook_timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "snapshot", kind: "message", T: () => SnapshotConfig, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "tool_dispatch_pool", kind: "message", T: () => PoolConfig, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "rate_limit", kind: "message", T: () => RateLimitConfig, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "supervision", kind: "message", T: () => SupervisionConfig, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "circuit_breaker", kind: "message", T: () => CircuitBreakerConfig, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "registry_lookup_timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 10, name: "registry_lookup_retry_delay", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 11, name: "registry_lookup_max_retries", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 0 } } } },
            { no: 9, name: "local", kind: "message", T: () => LocalConfig },
            { no: 12, name: "tool_registry", kind: "message", T: () => ToolRegistryConfig, options: { "buf.validate.field": { required: true } } },
            { no: 13, name: "hook_registry", kind: "message", T: () => HookRegistryConfig, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ActorConfig>): ActorConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.registryLookupMaxRetries = 0;
        if (value !== undefined)
            reflectionMergePartial<ActorConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorConfig): ActorConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration context_ready_timeout */ 1:
                    message.contextReadyTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.contextReadyTimeout);
                    break;
                case /* google.protobuf.Duration hook_timeout */ 2:
                    message.hookTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.hookTimeout);
                    break;
                case /* agency.config.v1.SnapshotConfig snapshot */ 3:
                    message.snapshot = SnapshotConfig.internalBinaryRead(reader, reader.uint32(), options, message.snapshot);
                    break;
                case /* agency.config.v1.PoolConfig tool_dispatch_pool */ 4:
                    message.toolDispatchPool = PoolConfig.internalBinaryRead(reader, reader.uint32(), options, message.toolDispatchPool);
                    break;
                case /* agency.config.v1.RateLimitConfig rate_limit */ 5:
                    message.rateLimit = RateLimitConfig.internalBinaryRead(reader, reader.uint32(), options, message.rateLimit);
                    break;
                case /* agency.config.v1.SupervisionConfig supervision */ 6:
                    message.supervision = SupervisionConfig.internalBinaryRead(reader, reader.uint32(), options, message.supervision);
                    break;
                case /* agency.config.v1.CircuitBreakerConfig circuit_breaker */ 7:
                    message.circuitBreaker = CircuitBreakerConfig.internalBinaryRead(reader, reader.uint32(), options, message.circuitBreaker);
                    break;
                case /* google.protobuf.Duration registry_lookup_timeout */ 8:
                    message.registryLookupTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.registryLookupTimeout);
                    break;
                case /* google.protobuf.Duration registry_lookup_retry_delay */ 10:
                    message.registryLookupRetryDelay = Duration.internalBinaryRead(reader, reader.uint32(), options, message.registryLookupRetryDelay);
                    break;
                case /* int32 registry_lookup_max_retries */ 11:
                    message.registryLookupMaxRetries = reader.int32();
                    break;
                case /* optional agency.config.v1.LocalConfig local */ 9:
                    message.local = LocalConfig.internalBinaryRead(reader, reader.uint32(), options, message.local);
                    break;
                case /* agency.config.v1.ToolRegistryConfig tool_registry */ 12:
                    message.toolRegistry = ToolRegistryConfig.internalBinaryRead(reader, reader.uint32(), options, message.toolRegistry);
                    break;
                case /* agency.config.v1.HookRegistryConfig hook_registry */ 13:
                    message.hookRegistry = HookRegistryConfig.internalBinaryRead(reader, reader.uint32(), options, message.hookRegistry);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration context_ready_timeout = 1; */
        if (message.contextReadyTimeout)
            Duration.internalBinaryWrite(message.contextReadyTimeout, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration hook_timeout = 2; */
        if (message.hookTimeout)
            Duration.internalBinaryWrite(message.hookTimeout, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.SnapshotConfig snapshot = 3; */
        if (message.snapshot)
            SnapshotConfig.internalBinaryWrite(message.snapshot, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.PoolConfig tool_dispatch_pool = 4; */
        if (message.toolDispatchPool)
            PoolConfig.internalBinaryWrite(message.toolDispatchPool, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.RateLimitConfig rate_limit = 5; */
        if (message.rateLimit)
            RateLimitConfig.internalBinaryWrite(message.rateLimit, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.SupervisionConfig supervision = 6; */
        if (message.supervision)
            SupervisionConfig.internalBinaryWrite(message.supervision, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.CircuitBreakerConfig circuit_breaker = 7; */
        if (message.circuitBreaker)
            CircuitBreakerConfig.internalBinaryWrite(message.circuitBreaker, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration registry_lookup_timeout = 8; */
        if (message.registryLookupTimeout)
            Duration.internalBinaryWrite(message.registryLookupTimeout, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional agency.config.v1.LocalConfig local = 9; */
        if (message.local)
            LocalConfig.internalBinaryWrite(message.local, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration registry_lookup_retry_delay = 10; */
        if (message.registryLookupRetryDelay)
            Duration.internalBinaryWrite(message.registryLookupRetryDelay, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 registry_lookup_max_retries = 11; */
        if (message.registryLookupMaxRetries !== 0)
            writer.tag(11, WireType.Varint).int32(message.registryLookupMaxRetries);
        /* agency.config.v1.ToolRegistryConfig tool_registry = 12; */
        if (message.toolRegistry)
            ToolRegistryConfig.internalBinaryWrite(message.toolRegistry, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.HookRegistryConfig hook_registry = 13; */
        if (message.hookRegistry)
            HookRegistryConfig.internalBinaryWrite(message.hookRegistry, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ActorConfig
 */
export const ActorConfig = new ActorConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HookRegistryConfig$Type extends MessageType<HookRegistryConfig> {
    constructor() {
        super("agency.config.v1.HookRegistryConfig", [
            { no: 1, name: "heartbeat_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 300, gte: 5 } } } },
            { no: 2, name: "eviction_ttl_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 600, gte: 10 } } } }
        ]);
    }
    create(value?: PartialMessage<HookRegistryConfig>): HookRegistryConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.heartbeatIntervalSeconds = 0;
        message.evictionTtlSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial<HookRegistryConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HookRegistryConfig): HookRegistryConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 heartbeat_interval_seconds */ 1:
                    message.heartbeatIntervalSeconds = reader.int32();
                    break;
                case /* int32 eviction_ttl_seconds */ 2:
                    message.evictionTtlSeconds = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HookRegistryConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 heartbeat_interval_seconds = 1; */
        if (message.heartbeatIntervalSeconds !== 0)
            writer.tag(1, WireType.Varint).int32(message.heartbeatIntervalSeconds);
        /* int32 eviction_ttl_seconds = 2; */
        if (message.evictionTtlSeconds !== 0)
            writer.tag(2, WireType.Varint).int32(message.evictionTtlSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.HookRegistryConfig
 */
export const HookRegistryConfig = new HookRegistryConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolRegistryConfig$Type extends MessageType<ToolRegistryConfig> {
    constructor() {
        super("agency.config.v1.ToolRegistryConfig", [
            { no: 1, name: "heartbeat_interval_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 300, gte: 5 } } } },
            { no: 2, name: "eviction_ttl_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 600, gte: 10 } } } },
            { no: 3, name: "tool_name_duplicate_policy", kind: "enum", T: () => ["agency.config.v1.HarnessDuplicatePolicy", HarnessDuplicatePolicy, "HARNESS_DUPLICATE_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<ToolRegistryConfig>): ToolRegistryConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.heartbeatIntervalSeconds = 0;
        message.evictionTtlSeconds = 0;
        message.toolNameDuplicatePolicy = 0;
        if (value !== undefined)
            reflectionMergePartial<ToolRegistryConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolRegistryConfig): ToolRegistryConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 heartbeat_interval_seconds */ 1:
                    message.heartbeatIntervalSeconds = reader.int32();
                    break;
                case /* int32 eviction_ttl_seconds */ 2:
                    message.evictionTtlSeconds = reader.int32();
                    break;
                case /* agency.config.v1.HarnessDuplicatePolicy tool_name_duplicate_policy */ 3:
                    message.toolNameDuplicatePolicy = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolRegistryConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 heartbeat_interval_seconds = 1; */
        if (message.heartbeatIntervalSeconds !== 0)
            writer.tag(1, WireType.Varint).int32(message.heartbeatIntervalSeconds);
        /* int32 eviction_ttl_seconds = 2; */
        if (message.evictionTtlSeconds !== 0)
            writer.tag(2, WireType.Varint).int32(message.evictionTtlSeconds);
        /* agency.config.v1.HarnessDuplicatePolicy tool_name_duplicate_policy = 3; */
        if (message.toolNameDuplicatePolicy !== 0)
            writer.tag(3, WireType.Varint).int32(message.toolNameDuplicatePolicy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ToolRegistryConfig
 */
export const ToolRegistryConfig = new ToolRegistryConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SnapshotConfig$Type extends MessageType<SnapshotConfig> {
    constructor() {
        super("agency.config.v1.SnapshotConfig", [
            { no: 1, name: "interval_steps", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 2, name: "interval_duration", kind: "message", T: () => Duration },
            { no: 3, name: "lock_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "object_store_threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10485760, gte: 1024 } } } }
        ]);
    }
    create(value?: PartialMessage<SnapshotConfig>): SnapshotConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.intervalSteps = 0;
        message.objectStoreThreshold = 0;
        if (value !== undefined)
            reflectionMergePartial<SnapshotConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SnapshotConfig): SnapshotConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 interval_steps */ 1:
                    message.intervalSteps = reader.int32();
                    break;
                case /* google.protobuf.Duration interval_duration */ 2:
                    message.intervalDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.intervalDuration);
                    break;
                case /* google.protobuf.Duration lock_ttl */ 3:
                    message.lockTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.lockTtl);
                    break;
                case /* int32 object_store_threshold */ 4:
                    message.objectStoreThreshold = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SnapshotConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 interval_steps = 1; */
        if (message.intervalSteps !== 0)
            writer.tag(1, WireType.Varint).int32(message.intervalSteps);
        /* google.protobuf.Duration interval_duration = 2; */
        if (message.intervalDuration)
            Duration.internalBinaryWrite(message.intervalDuration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration lock_ttl = 3; */
        if (message.lockTtl)
            Duration.internalBinaryWrite(message.lockTtl, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 object_store_threshold = 4; */
        if (message.objectStoreThreshold !== 0)
            writer.tag(4, WireType.Varint).int32(message.objectStoreThreshold);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.SnapshotConfig
 */
export const SnapshotConfig = new SnapshotConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoolConfig$Type extends MessageType<PoolConfig> {
    constructor() {
        super("agency.config.v1.PoolConfig", [
            { no: 1, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 1 } } } },
            { no: 2, name: "queue_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100000, gte: 1 } } } },
            { no: 3, name: "exclusive_tools", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<PoolConfig>): PoolConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.size = 0;
        message.queueSize = 0;
        message.exclusiveTools = [];
        if (value !== undefined)
            reflectionMergePartial<PoolConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PoolConfig): PoolConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 size */ 1:
                    message.size = reader.int32();
                    break;
                case /* int32 queue_size */ 2:
                    message.queueSize = reader.int32();
                    break;
                case /* repeated string exclusive_tools */ 3:
                    message.exclusiveTools.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PoolConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 size = 1; */
        if (message.size !== 0)
            writer.tag(1, WireType.Varint).int32(message.size);
        /* int32 queue_size = 2; */
        if (message.queueSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.queueSize);
        /* repeated string exclusive_tools = 3; */
        for (let i = 0; i < message.exclusiveTools.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.exclusiveTools[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.PoolConfig
 */
export const PoolConfig = new PoolConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RateLimitConfig$Type extends MessageType<RateLimitConfig> {
    constructor() {
        super("agency.config.v1.RateLimitConfig", [
            { no: 1, name: "rps_limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000000, gte: 1 } } } },
            { no: 2, name: "burst", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } },
            { no: 3, name: "per_user_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "per_tenant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RateLimitConfig>): RateLimitConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rpsLimit = 0;
        message.burst = 0;
        message.perUserEnabled = false;
        message.perTenantEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<RateLimitConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RateLimitConfig): RateLimitConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 rps_limit */ 1:
                    message.rpsLimit = reader.int32();
                    break;
                case /* int32 burst */ 2:
                    message.burst = reader.int32();
                    break;
                case /* bool per_user_enabled */ 3:
                    message.perUserEnabled = reader.bool();
                    break;
                case /* bool per_tenant_enabled */ 4:
                    message.perTenantEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RateLimitConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 rps_limit = 1; */
        if (message.rpsLimit !== 0)
            writer.tag(1, WireType.Varint).int32(message.rpsLimit);
        /* int32 burst = 2; */
        if (message.burst !== 0)
            writer.tag(2, WireType.Varint).int32(message.burst);
        /* bool per_user_enabled = 3; */
        if (message.perUserEnabled !== false)
            writer.tag(3, WireType.Varint).bool(message.perUserEnabled);
        /* bool per_tenant_enabled = 4; */
        if (message.perTenantEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.perTenantEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.RateLimitConfig
 */
export const RateLimitConfig = new RateLimitConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SupervisionConfig$Type extends MessageType<SupervisionConfig> {
    constructor() {
        super("agency.config.v1.SupervisionConfig", [
            { no: 1, name: "max_restarts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 2, name: "restart_delay", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SupervisionConfig>): SupervisionConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxRestarts = 0;
        if (value !== undefined)
            reflectionMergePartial<SupervisionConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SupervisionConfig): SupervisionConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 max_restarts */ 1:
                    message.maxRestarts = reader.int32();
                    break;
                case /* google.protobuf.Duration restart_delay */ 2:
                    message.restartDelay = Duration.internalBinaryRead(reader, reader.uint32(), options, message.restartDelay);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SupervisionConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 max_restarts = 1; */
        if (message.maxRestarts !== 0)
            writer.tag(1, WireType.Varint).int32(message.maxRestarts);
        /* google.protobuf.Duration restart_delay = 2; */
        if (message.restartDelay)
            Duration.internalBinaryWrite(message.restartDelay, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.SupervisionConfig
 */
export const SupervisionConfig = new SupervisionConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SupervisorConfig$Type extends MessageType<SupervisorConfig> {
    constructor() {
        super("agency.config.v1.SupervisorConfig", [
            { no: 1, name: "strategy", kind: "enum", T: () => ["agency.config.v1.SupervisionStrategy", SupervisionStrategy, "SUPERVISION_STRATEGY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "max_restarts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 3, name: "restart_window", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "backoff_durations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Duration, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10" } } } }
        ]);
    }
    create(value?: PartialMessage<SupervisorConfig>): SupervisorConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.strategy = 0;
        message.maxRestarts = 0;
        message.backoffDurations = [];
        if (value !== undefined)
            reflectionMergePartial<SupervisorConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SupervisorConfig): SupervisorConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.config.v1.SupervisionStrategy strategy */ 1:
                    message.strategy = reader.int32();
                    break;
                case /* int32 max_restarts */ 2:
                    message.maxRestarts = reader.int32();
                    break;
                case /* google.protobuf.Duration restart_window */ 3:
                    message.restartWindow = Duration.internalBinaryRead(reader, reader.uint32(), options, message.restartWindow);
                    break;
                case /* repeated google.protobuf.Duration backoff_durations */ 4:
                    message.backoffDurations.push(Duration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SupervisorConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.config.v1.SupervisionStrategy strategy = 1; */
        if (message.strategy !== 0)
            writer.tag(1, WireType.Varint).int32(message.strategy);
        /* int32 max_restarts = 2; */
        if (message.maxRestarts !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxRestarts);
        /* google.protobuf.Duration restart_window = 3; */
        if (message.restartWindow)
            Duration.internalBinaryWrite(message.restartWindow, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Duration backoff_durations = 4; */
        for (let i = 0; i < message.backoffDurations.length; i++)
            Duration.internalBinaryWrite(message.backoffDurations[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.SupervisorConfig
 */
export const SupervisorConfig = new SupervisorConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CircuitBreakerConfig$Type extends MessageType<CircuitBreakerConfig> {
    constructor() {
        super("agency.config.v1.CircuitBreakerConfig", [
            { no: 1, name: "max_requests", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 1000, gte: 1 } } } },
            { no: 2, name: "interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "consecutive_failures", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 100, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<CircuitBreakerConfig>): CircuitBreakerConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxRequests = 0;
        message.consecutiveFailures = 0;
        if (value !== undefined)
            reflectionMergePartial<CircuitBreakerConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CircuitBreakerConfig): CircuitBreakerConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 max_requests */ 1:
                    message.maxRequests = reader.uint32();
                    break;
                case /* google.protobuf.Duration interval */ 2:
                    message.interval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.interval);
                    break;
                case /* google.protobuf.Duration timeout */ 3:
                    message.timeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                case /* uint32 consecutive_failures */ 4:
                    message.consecutiveFailures = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CircuitBreakerConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 max_requests = 1; */
        if (message.maxRequests !== 0)
            writer.tag(1, WireType.Varint).uint32(message.maxRequests);
        /* google.protobuf.Duration interval = 2; */
        if (message.interval)
            Duration.internalBinaryWrite(message.interval, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration timeout = 3; */
        if (message.timeout)
            Duration.internalBinaryWrite(message.timeout, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* uint32 consecutive_failures = 4; */
        if (message.consecutiveFailures !== 0)
            writer.tag(4, WireType.Varint).uint32(message.consecutiveFailures);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.CircuitBreakerConfig
 */
export const CircuitBreakerConfig = new CircuitBreakerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalConfig$Type extends MessageType<LocalConfig> {
    constructor() {
        super("agency.config.v1.LocalConfig", [
            { no: 1, name: "ticker_interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "urn_template", kind: "message", T: () => URNTemplate, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<LocalConfig>): LocalConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LocalConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalConfig): LocalConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration ticker_interval */ 1:
                    message.tickerInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.tickerInterval);
                    break;
                case /* agency.config.v1.URNTemplate urn_template */ 2:
                    message.urnTemplate = URNTemplate.internalBinaryRead(reader, reader.uint32(), options, message.urnTemplate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration ticker_interval = 1; */
        if (message.tickerInterval)
            Duration.internalBinaryWrite(message.tickerInterval, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.URNTemplate urn_template = 2; */
        if (message.urnTemplate)
            URNTemplate.internalBinaryWrite(message.urnTemplate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.LocalConfig
 */
export const LocalConfig = new LocalConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNTemplate$Type extends MessageType<URNTemplate> {
    constructor() {
        super("agency.config.v1.URNTemplate", [
            { no: 1, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "kind", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "instance", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<URNTemplate>): URNTemplate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.region = "";
        message.kind = "";
        message.instance = "";
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        if (value !== undefined)
            reflectionMergePartial<URNTemplate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNTemplate): URNTemplate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string region */ 1:
                    message.region = reader.string();
                    break;
                case /* string kind */ 2:
                    message.kind = reader.string();
                    break;
                case /* string instance */ 3:
                    message.instance = reader.string();
                    break;
                case /* string tenant */ 4:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 5:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 6:
                    message.session = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNTemplate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string region = 1; */
        if (message.region !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.region);
        /* string kind = 2; */
        if (message.kind !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.kind);
        /* string instance = 3; */
        if (message.instance !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.instance);
        /* string tenant = 4; */
        if (message.tenant !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 5; */
        if (message.workspace !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.workspace);
        /* string session = 6; */
        if (message.session !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.session);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.URNTemplate
 */
export const URNTemplate = new URNTemplate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ObservabilityConfig$Type extends MessageType<ObservabilityConfig> {
    constructor() {
        super("agency.config.v1.ObservabilityConfig", [
            { no: 1, name: "otlp_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 2, name: "otlp_insecure", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "trace_sampling_rate", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 4, name: "metrics_interval", kind: "message", T: () => Duration },
            { no: 5, name: "enable_trace_export", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "enable_metrics_export", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ObservabilityConfig>): ObservabilityConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.otlpEndpoint = "";
        message.otlpInsecure = false;
        message.traceSamplingRate = 0;
        message.enableTraceExport = false;
        message.enableMetricsExport = false;
        if (value !== undefined)
            reflectionMergePartial<ObservabilityConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ObservabilityConfig): ObservabilityConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string otlp_endpoint */ 1:
                    message.otlpEndpoint = reader.string();
                    break;
                case /* bool otlp_insecure */ 2:
                    message.otlpInsecure = reader.bool();
                    break;
                case /* float trace_sampling_rate */ 3:
                    message.traceSamplingRate = reader.float();
                    break;
                case /* google.protobuf.Duration metrics_interval */ 4:
                    message.metricsInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.metricsInterval);
                    break;
                case /* bool enable_trace_export */ 5:
                    message.enableTraceExport = reader.bool();
                    break;
                case /* bool enable_metrics_export */ 6:
                    message.enableMetricsExport = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ObservabilityConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string otlp_endpoint = 1; */
        if (message.otlpEndpoint !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.otlpEndpoint);
        /* bool otlp_insecure = 2; */
        if (message.otlpInsecure !== false)
            writer.tag(2, WireType.Varint).bool(message.otlpInsecure);
        /* float trace_sampling_rate = 3; */
        if (message.traceSamplingRate !== 0)
            writer.tag(3, WireType.Bit32).float(message.traceSamplingRate);
        /* google.protobuf.Duration metrics_interval = 4; */
        if (message.metricsInterval)
            Duration.internalBinaryWrite(message.metricsInterval, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool enable_trace_export = 5; */
        if (message.enableTraceExport !== false)
            writer.tag(5, WireType.Varint).bool(message.enableTraceExport);
        /* bool enable_metrics_export = 6; */
        if (message.enableMetricsExport !== false)
            writer.tag(6, WireType.Varint).bool(message.enableMetricsExport);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ObservabilityConfig
 */
export const ObservabilityConfig = new ObservabilityConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FederationConfig$Type extends MessageType<FederationConfig> {
    constructor() {
        super("agency.config.v1.FederationConfig", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "remotes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RemoteHarnessConfig, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 4, name: "leafnode_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 5, name: "leafnode_credentials_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<FederationConfig>): FederationConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.harnessId = "";
        message.remotes = [];
        message.leafnodeUrl = "";
        message.leafnodeCredentialsPath = "";
        if (value !== undefined)
            reflectionMergePartial<FederationConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FederationConfig): FederationConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string harness_id */ 2:
                    message.harnessId = reader.string();
                    break;
                case /* repeated agency.config.v1.RemoteHarnessConfig remotes */ 3:
                    message.remotes.push(RemoteHarnessConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string leafnode_url */ 4:
                    message.leafnodeUrl = reader.string();
                    break;
                case /* string leafnode_credentials_path */ 5:
                    message.leafnodeCredentialsPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FederationConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string harness_id = 2; */
        if (message.harnessId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.harnessId);
        /* repeated agency.config.v1.RemoteHarnessConfig remotes = 3; */
        for (let i = 0; i < message.remotes.length; i++)
            RemoteHarnessConfig.internalBinaryWrite(message.remotes[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string leafnode_url = 4; */
        if (message.leafnodeUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.leafnodeUrl);
        /* string leafnode_credentials_path = 5; */
        if (message.leafnodeCredentialsPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.leafnodeCredentialsPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.FederationConfig
 */
export const FederationConfig = new FederationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteHarnessConfig$Type extends MessageType<RemoteHarnessConfig> {
    constructor() {
        super("agency.config.v1.RemoteHarnessConfig", [
            { no: 1, name: "harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "leafnode_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "trust_level", kind: "enum", T: () => ["agency.config.v1.TrustLevel", TrustLevel, "TRUST_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "allowed_tenants", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RemoteHarnessConfig>): RemoteHarnessConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessId = "";
        message.leafnodeUrl = "";
        message.trustLevel = 0;
        message.allowedTenants = [];
        if (value !== undefined)
            reflectionMergePartial<RemoteHarnessConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteHarnessConfig): RemoteHarnessConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string harness_id */ 1:
                    message.harnessId = reader.string();
                    break;
                case /* string leafnode_url */ 2:
                    message.leafnodeUrl = reader.string();
                    break;
                case /* agency.config.v1.TrustLevel trust_level */ 3:
                    message.trustLevel = reader.int32();
                    break;
                case /* repeated string allowed_tenants */ 4:
                    message.allowedTenants.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteHarnessConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string harness_id = 1; */
        if (message.harnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.harnessId);
        /* string leafnode_url = 2; */
        if (message.leafnodeUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.leafnodeUrl);
        /* agency.config.v1.TrustLevel trust_level = 3; */
        if (message.trustLevel !== 0)
            writer.tag(3, WireType.Varint).int32(message.trustLevel);
        /* repeated string allowed_tenants = 4; */
        for (let i = 0; i < message.allowedTenants.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.allowedTenants[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.RemoteHarnessConfig
 */
export const RemoteHarnessConfig = new RemoteHarnessConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HarnessClaimConfig$Type extends MessageType<HarnessClaimConfig> {
    constructor() {
        super("agency.config.v1.HarnessClaimConfig", [
            { no: 1, name: "duplicate_policy", kind: "enum", T: () => ["agency.config.v1.HarnessDuplicatePolicy", HarnessDuplicatePolicy, "HARNESS_DUPLICATE_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "lease_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "heartbeat_interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "evict_grace_period", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "bucket_replicas", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 5, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<HarnessClaimConfig>): HarnessClaimConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.duplicatePolicy = 0;
        message.bucketReplicas = 0;
        if (value !== undefined)
            reflectionMergePartial<HarnessClaimConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HarnessClaimConfig): HarnessClaimConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.config.v1.HarnessDuplicatePolicy duplicate_policy */ 1:
                    message.duplicatePolicy = reader.int32();
                    break;
                case /* google.protobuf.Duration lease_ttl */ 2:
                    message.leaseTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.leaseTtl);
                    break;
                case /* google.protobuf.Duration heartbeat_interval */ 3:
                    message.heartbeatInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.heartbeatInterval);
                    break;
                case /* google.protobuf.Duration evict_grace_period */ 4:
                    message.evictGracePeriod = Duration.internalBinaryRead(reader, reader.uint32(), options, message.evictGracePeriod);
                    break;
                case /* uint32 bucket_replicas */ 5:
                    message.bucketReplicas = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HarnessClaimConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.config.v1.HarnessDuplicatePolicy duplicate_policy = 1; */
        if (message.duplicatePolicy !== 0)
            writer.tag(1, WireType.Varint).int32(message.duplicatePolicy);
        /* google.protobuf.Duration lease_ttl = 2; */
        if (message.leaseTtl)
            Duration.internalBinaryWrite(message.leaseTtl, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration heartbeat_interval = 3; */
        if (message.heartbeatInterval)
            Duration.internalBinaryWrite(message.heartbeatInterval, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration evict_grace_period = 4; */
        if (message.evictGracePeriod)
            Duration.internalBinaryWrite(message.evictGracePeriod, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* uint32 bucket_replicas = 5; */
        if (message.bucketReplicas !== 0)
            writer.tag(5, WireType.Varint).uint32(message.bucketReplicas);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.HarnessClaimConfig
 */
export const HarnessClaimConfig = new HarnessClaimConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OperationsConfig$Type extends MessageType<OperationsConfig> {
    constructor() {
        super("agency.config.v1.OperationsConfig", [
            { no: 1, name: "health_probe_addr", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "drain_timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "dlq", kind: "message", T: () => DLQConfig, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "claim", kind: "message", T: () => HarnessClaimConfig, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "provider_claim", kind: "message", T: () => ProviderClaimConfig, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<OperationsConfig>): OperationsConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.healthProbeAddr = "";
        if (value !== undefined)
            reflectionMergePartial<OperationsConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OperationsConfig): OperationsConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string health_probe_addr */ 1:
                    message.healthProbeAddr = reader.string();
                    break;
                case /* google.protobuf.Duration drain_timeout */ 2:
                    message.drainTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.drainTimeout);
                    break;
                case /* agency.config.v1.DLQConfig dlq */ 3:
                    message.dlq = DLQConfig.internalBinaryRead(reader, reader.uint32(), options, message.dlq);
                    break;
                case /* agency.config.v1.HarnessClaimConfig claim */ 4:
                    message.claim = HarnessClaimConfig.internalBinaryRead(reader, reader.uint32(), options, message.claim);
                    break;
                case /* agency.config.v1.ProviderClaimConfig provider_claim */ 5:
                    message.providerClaim = ProviderClaimConfig.internalBinaryRead(reader, reader.uint32(), options, message.providerClaim);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OperationsConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string health_probe_addr = 1; */
        if (message.healthProbeAddr !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.healthProbeAddr);
        /* google.protobuf.Duration drain_timeout = 2; */
        if (message.drainTimeout)
            Duration.internalBinaryWrite(message.drainTimeout, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.DLQConfig dlq = 3; */
        if (message.dlq)
            DLQConfig.internalBinaryWrite(message.dlq, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.HarnessClaimConfig claim = 4; */
        if (message.claim)
            HarnessClaimConfig.internalBinaryWrite(message.claim, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.ProviderClaimConfig provider_claim = 5; */
        if (message.providerClaim)
            ProviderClaimConfig.internalBinaryWrite(message.providerClaim, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.OperationsConfig
 */
export const OperationsConfig = new OperationsConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProviderClaimConfig$Type extends MessageType<ProviderClaimConfig> {
    constructor() {
        super("agency.config.v1.ProviderClaimConfig", [
            { no: 1, name: "evict_grace_period", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ProviderClaimConfig>): ProviderClaimConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProviderClaimConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProviderClaimConfig): ProviderClaimConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration evict_grace_period */ 1:
                    message.evictGracePeriod = Duration.internalBinaryRead(reader, reader.uint32(), options, message.evictGracePeriod);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProviderClaimConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration evict_grace_period = 1; */
        if (message.evictGracePeriod)
            Duration.internalBinaryWrite(message.evictGracePeriod, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ProviderClaimConfig
 */
export const ProviderClaimConfig = new ProviderClaimConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DLQConfig$Type extends MessageType<DLQConfig> {
    constructor() {
        super("agency.config.v1.DLQConfig", [
            { no: 1, name: "alert_threshold_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } },
            { no: 2, name: "alert_threshold_rate", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 3, name: "retention", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "retry_policy", kind: "enum", T: () => ["agency.config.v1.DLQRetryPolicy", DLQRetryPolicy] }
        ]);
    }
    create(value?: PartialMessage<DLQConfig>): DLQConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertThresholdCount = 0;
        message.alertThresholdRate = 0;
        message.retryPolicy = 0;
        if (value !== undefined)
            reflectionMergePartial<DLQConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DLQConfig): DLQConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 alert_threshold_count */ 1:
                    message.alertThresholdCount = reader.int32();
                    break;
                case /* float alert_threshold_rate */ 2:
                    message.alertThresholdRate = reader.float();
                    break;
                case /* google.protobuf.Duration retention */ 3:
                    message.retention = Duration.internalBinaryRead(reader, reader.uint32(), options, message.retention);
                    break;
                case /* agency.config.v1.DLQRetryPolicy retry_policy */ 4:
                    message.retryPolicy = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DLQConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 alert_threshold_count = 1; */
        if (message.alertThresholdCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.alertThresholdCount);
        /* float alert_threshold_rate = 2; */
        if (message.alertThresholdRate !== 0)
            writer.tag(2, WireType.Bit32).float(message.alertThresholdRate);
        /* google.protobuf.Duration retention = 3; */
        if (message.retention)
            Duration.internalBinaryWrite(message.retention, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.DLQRetryPolicy retry_policy = 4; */
        if (message.retryPolicy !== 0)
            writer.tag(4, WireType.Varint).int32(message.retryPolicy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.DLQConfig
 */
export const DLQConfig = new DLQConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DLQRetryRequest$Type extends MessageType<DLQRetryRequest> {
    constructor() {
        super("agency.config.v1.DLQRetryRequest", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "max_attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 1 } } } },
            { no: 4, name: "initial_delay", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "max_delay", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "backoff_multiplier", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 10, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<DLQRetryRequest>): DLQRetryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.maxAttempts = 0;
        message.backoffMultiplier = 0;
        if (value !== undefined)
            reflectionMergePartial<DLQRetryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DLQRetryRequest): DLQRetryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* int32 max_attempts */ 3:
                    message.maxAttempts = reader.int32();
                    break;
                case /* google.protobuf.Duration initial_delay */ 4:
                    message.initialDelay = Duration.internalBinaryRead(reader, reader.uint32(), options, message.initialDelay);
                    break;
                case /* google.protobuf.Duration max_delay */ 5:
                    message.maxDelay = Duration.internalBinaryRead(reader, reader.uint32(), options, message.maxDelay);
                    break;
                case /* float backoff_multiplier */ 6:
                    message.backoffMultiplier = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DLQRetryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* int32 max_attempts = 3; */
        if (message.maxAttempts !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxAttempts);
        /* google.protobuf.Duration initial_delay = 4; */
        if (message.initialDelay)
            Duration.internalBinaryWrite(message.initialDelay, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration max_delay = 5; */
        if (message.maxDelay)
            Duration.internalBinaryWrite(message.maxDelay, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* float backoff_multiplier = 6; */
        if (message.backoffMultiplier !== 0)
            writer.tag(6, WireType.Bit32).float(message.backoffMultiplier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.DLQRetryRequest
 */
export const DLQRetryRequest = new DLQRetryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DLQReplayRequest$Type extends MessageType<DLQReplayRequest> {
    constructor() {
        super("agency.config.v1.DLQReplayRequest", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "message_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "1000", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 4, name: "since_timestamp", kind: "message", T: () => Timestamp },
            { no: 5, name: "until_timestamp", kind: "message", T: () => Timestamp },
            { no: 6, name: "dry_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DLQReplayRequest>): DLQReplayRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.messageIds = [];
        message.dryRun = false;
        if (value !== undefined)
            reflectionMergePartial<DLQReplayRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DLQReplayRequest): DLQReplayRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* repeated string message_ids */ 3:
                    message.messageIds.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp since_timestamp */ 4:
                    message.sinceTimestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sinceTimestamp);
                    break;
                case /* google.protobuf.Timestamp until_timestamp */ 5:
                    message.untilTimestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.untilTimestamp);
                    break;
                case /* bool dry_run */ 6:
                    message.dryRun = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DLQReplayRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* repeated string message_ids = 3; */
        for (let i = 0; i < message.messageIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.messageIds[i]);
        /* google.protobuf.Timestamp since_timestamp = 4; */
        if (message.sinceTimestamp)
            Timestamp.internalBinaryWrite(message.sinceTimestamp, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp until_timestamp = 5; */
        if (message.untilTimestamp)
            Timestamp.internalBinaryWrite(message.untilTimestamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool dry_run = 6; */
        if (message.dryRun !== false)
            writer.tag(6, WireType.Varint).bool(message.dryRun);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.DLQReplayRequest
 */
export const DLQReplayRequest = new DLQReplayRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DLQRetryResponse$Type extends MessageType<DLQRetryResponse> {
    constructor() {
        super("agency.config.v1.DLQRetryResponse", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "messages_replayed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "messages_failed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "started_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "dry_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DLQRetryResponse>): DLQRetryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.messagesReplayed = 0;
        message.messagesFailed = 0;
        message.dryRun = false;
        if (value !== undefined)
            reflectionMergePartial<DLQRetryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DLQRetryResponse): DLQRetryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* int32 messages_replayed */ 3:
                    message.messagesReplayed = reader.int32();
                    break;
                case /* int32 messages_failed */ 4:
                    message.messagesFailed = reader.int32();
                    break;
                case /* google.protobuf.Timestamp started_at */ 5:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 6:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* bool dry_run */ 7:
                    message.dryRun = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DLQRetryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* int32 messages_replayed = 3; */
        if (message.messagesReplayed !== 0)
            writer.tag(3, WireType.Varint).int32(message.messagesReplayed);
        /* int32 messages_failed = 4; */
        if (message.messagesFailed !== 0)
            writer.tag(4, WireType.Varint).int32(message.messagesFailed);
        /* google.protobuf.Timestamp started_at = 5; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 6; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool dry_run = 7; */
        if (message.dryRun !== false)
            writer.tag(7, WireType.Varint).bool(message.dryRun);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.DLQRetryResponse
 */
export const DLQRetryResponse = new DLQRetryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamPolicyFile$Type extends MessageType<StreamPolicyFile> {
    constructor() {
        super("agency.config.v1.StreamPolicyFile", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$" } } } },
            { no: 2, name: "streams", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => StreamPolicy }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<StreamPolicyFile>): StreamPolicyFile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.version = "";
        message.streams = {};
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<StreamPolicyFile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamPolicyFile): StreamPolicyFile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                case /* map<string, agency.policy.v1.StreamPolicy> streams */ 2:
                    this.binaryReadMap2(message.streams, reader, options);
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: StreamPolicyFile["streams"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof StreamPolicyFile["streams"] | undefined, val: StreamPolicyFile["streams"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = StreamPolicy.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.StreamPolicyFile.streams");
            }
        }
        map[key ?? ""] = val ?? StreamPolicy.create();
    }
    private binaryReadMap3(map: StreamPolicyFile["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof StreamPolicyFile["metadata"] | undefined, val: StreamPolicyFile["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.StreamPolicyFile.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: StreamPolicyFile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        /* map<string, agency.policy.v1.StreamPolicy> streams = 2; */
        for (let k of globalThis.Object.keys(message.streams)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            StreamPolicy.internalBinaryWrite(message.streams[k], writer, options);
            writer.join().join();
        }
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.StreamPolicyFile
 */
export const StreamPolicyFile = new StreamPolicyFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerPolicyFile$Type extends MessageType<ConsumerPolicyFile> {
    constructor() {
        super("agency.config.v1.ConsumerPolicyFile", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$" } } } },
            { no: 2, name: "consumers", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConsumerPolicy }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerPolicyFile>): ConsumerPolicyFile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.version = "";
        message.consumers = {};
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ConsumerPolicyFile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerPolicyFile): ConsumerPolicyFile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                case /* map<string, agency.policy.v1.ConsumerPolicy> consumers */ 2:
                    this.binaryReadMap2(message.consumers, reader, options);
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ConsumerPolicyFile["consumers"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConsumerPolicyFile["consumers"] | undefined, val: ConsumerPolicyFile["consumers"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ConsumerPolicy.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.ConsumerPolicyFile.consumers");
            }
        }
        map[key ?? ""] = val ?? ConsumerPolicy.create();
    }
    private binaryReadMap3(map: ConsumerPolicyFile["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConsumerPolicyFile["metadata"] | undefined, val: ConsumerPolicyFile["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.ConsumerPolicyFile.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ConsumerPolicyFile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        /* map<string, agency.policy.v1.ConsumerPolicy> consumers = 2; */
        for (let k of globalThis.Object.keys(message.consumers)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ConsumerPolicy.internalBinaryWrite(message.consumers[k], writer, options);
            writer.join().join();
        }
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerPolicyFile
 */
export const ConsumerPolicyFile = new ConsumerPolicyFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TierConfigFile$Type extends MessageType<TierConfigFile> {
    constructor() {
        super("agency.config.v1.TierConfigFile", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$" } } } },
            { no: 2, name: "tiers", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TierConfig }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<TierConfigFile>): TierConfigFile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.version = "";
        message.tiers = {};
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<TierConfigFile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TierConfigFile): TierConfigFile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                case /* map<string, agency.billing.v1.TierConfig> tiers */ 2:
                    this.binaryReadMap2(message.tiers, reader, options);
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: TierConfigFile["tiers"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TierConfigFile["tiers"] | undefined, val: TierConfigFile["tiers"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TierConfig.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.TierConfigFile.tiers");
            }
        }
        map[key ?? ""] = val ?? TierConfig.create();
    }
    private binaryReadMap3(map: TierConfigFile["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TierConfigFile["metadata"] | undefined, val: TierConfigFile["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.TierConfigFile.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: TierConfigFile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        /* map<string, agency.billing.v1.TierConfig> tiers = 2; */
        for (let k of globalThis.Object.keys(message.tiers)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TierConfig.internalBinaryWrite(message.tiers[k], writer, options);
            writer.join().join();
        }
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.TierConfigFile
 */
export const TierConfigFile = new TierConfigFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProviderConfigFile$Type extends MessageType<ProviderConfigFile> {
    constructor() {
        super("agency.config.v1.ProviderConfigFile", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$" } } } },
            { no: 2, name: "providers", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ModelConfig }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ProviderConfigFile>): ProviderConfigFile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.version = "";
        message.providers = {};
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ProviderConfigFile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProviderConfigFile): ProviderConfigFile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                case /* map<string, agency.model.v1.ModelConfig> providers */ 2:
                    this.binaryReadMap2(message.providers, reader, options);
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ProviderConfigFile["providers"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ProviderConfigFile["providers"] | undefined, val: ProviderConfigFile["providers"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ModelConfig.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.ProviderConfigFile.providers");
            }
        }
        map[key ?? ""] = val ?? ModelConfig.create();
    }
    private binaryReadMap3(map: ProviderConfigFile["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ProviderConfigFile["metadata"] | undefined, val: ProviderConfigFile["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.ProviderConfigFile.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ProviderConfigFile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        /* map<string, agency.model.v1.ModelConfig> providers = 2; */
        for (let k of globalThis.Object.keys(message.providers)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ModelConfig.internalBinaryWrite(message.providers[k], writer, options);
            writer.join().join();
        }
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ProviderConfigFile
 */
export const ProviderConfigFile = new ProviderConfigFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillingConfig$Type extends MessageType<BillingConfig> {
    constructor() {
        super("agency.config.v1.BillingConfig", [
            { no: 1, name: "rollup_interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "export_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "export_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 4, name: "export_batch_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<BillingConfig>): BillingConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportEnabled = false;
        message.exportEndpoint = "";
        message.exportBatchSize = 0;
        if (value !== undefined)
            reflectionMergePartial<BillingConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BillingConfig): BillingConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration rollup_interval */ 1:
                    message.rollupInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.rollupInterval);
                    break;
                case /* bool export_enabled */ 2:
                    message.exportEnabled = reader.bool();
                    break;
                case /* string export_endpoint */ 3:
                    message.exportEndpoint = reader.string();
                    break;
                case /* int32 export_batch_size */ 4:
                    message.exportBatchSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BillingConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration rollup_interval = 1; */
        if (message.rollupInterval)
            Duration.internalBinaryWrite(message.rollupInterval, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool export_enabled = 2; */
        if (message.exportEnabled !== false)
            writer.tag(2, WireType.Varint).bool(message.exportEnabled);
        /* string export_endpoint = 3; */
        if (message.exportEndpoint !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.exportEndpoint);
        /* int32 export_batch_size = 4; */
        if (message.exportBatchSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.exportBatchSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.BillingConfig
 */
export const BillingConfig = new BillingConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SecurityConfig$Type extends MessageType<SecurityConfig> {
    constructor() {
        super("agency.config.v1.SecurityConfig", [
            { no: 1, name: "credential_cache_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "credential_retry_backoff", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Duration, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10" } } } },
            { no: 3, name: "credential_max_retries", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 1 } } } },
            { no: 4, name: "sops_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "age_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "key_rotation_interval", kind: "message", T: () => Duration },
            { no: 7, name: "require_age_for_edge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "client_nats_user_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "client_cert_ttl", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SecurityConfig>): SecurityConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.credentialRetryBackoff = [];
        message.credentialMaxRetries = 0;
        message.sopsEnabled = false;
        message.ageEnabled = false;
        message.requireAgeForEdge = false;
        if (value !== undefined)
            reflectionMergePartial<SecurityConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SecurityConfig): SecurityConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration credential_cache_ttl */ 1:
                    message.credentialCacheTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.credentialCacheTtl);
                    break;
                case /* repeated google.protobuf.Duration credential_retry_backoff */ 2:
                    message.credentialRetryBackoff.push(Duration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 credential_max_retries */ 3:
                    message.credentialMaxRetries = reader.int32();
                    break;
                case /* bool sops_enabled */ 4:
                    message.sopsEnabled = reader.bool();
                    break;
                case /* bool age_enabled */ 5:
                    message.ageEnabled = reader.bool();
                    break;
                case /* google.protobuf.Duration key_rotation_interval */ 6:
                    message.keyRotationInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.keyRotationInterval);
                    break;
                case /* bool require_age_for_edge */ 7:
                    message.requireAgeForEdge = reader.bool();
                    break;
                case /* google.protobuf.Duration client_nats_user_ttl */ 8:
                    message.clientNatsUserTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.clientNatsUserTtl);
                    break;
                case /* google.protobuf.Duration client_cert_ttl */ 9:
                    message.clientCertTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.clientCertTtl);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SecurityConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration credential_cache_ttl = 1; */
        if (message.credentialCacheTtl)
            Duration.internalBinaryWrite(message.credentialCacheTtl, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Duration credential_retry_backoff = 2; */
        for (let i = 0; i < message.credentialRetryBackoff.length; i++)
            Duration.internalBinaryWrite(message.credentialRetryBackoff[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 credential_max_retries = 3; */
        if (message.credentialMaxRetries !== 0)
            writer.tag(3, WireType.Varint).int32(message.credentialMaxRetries);
        /* bool sops_enabled = 4; */
        if (message.sopsEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.sopsEnabled);
        /* bool age_enabled = 5; */
        if (message.ageEnabled !== false)
            writer.tag(5, WireType.Varint).bool(message.ageEnabled);
        /* google.protobuf.Duration key_rotation_interval = 6; */
        if (message.keyRotationInterval)
            Duration.internalBinaryWrite(message.keyRotationInterval, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool require_age_for_edge = 7; */
        if (message.requireAgeForEdge !== false)
            writer.tag(7, WireType.Varint).bool(message.requireAgeForEdge);
        /* google.protobuf.Duration client_nats_user_ttl = 8; */
        if (message.clientNatsUserTtl)
            Duration.internalBinaryWrite(message.clientNatsUserTtl, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration client_cert_ttl = 9; */
        if (message.clientCertTtl)
            Duration.internalBinaryWrite(message.clientCertTtl, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.SecurityConfig
 */
export const SecurityConfig = new SecurityConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialConfig$Type extends MessageType<CredentialConfig> {
    constructor() {
        super("agency.config.v1.CredentialConfig", [
            { no: 1, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "config_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 3, name: "cache_ttl", kind: "message", T: () => Duration },
            { no: 4, name: "retry_backoff", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Duration, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 5, name: "max_retries", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 0 } } } },
            { no: 6, name: "params", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 7, name: "circuit_breaker", kind: "message", T: () => CircuitBreakerConfig }
        ]);
    }
    create(value?: PartialMessage<CredentialConfig>): CredentialConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.provider = "";
        message.configPath = "";
        message.retryBackoff = [];
        message.maxRetries = 0;
        message.params = {};
        if (value !== undefined)
            reflectionMergePartial<CredentialConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialConfig): CredentialConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string provider */ 1:
                    message.provider = reader.string();
                    break;
                case /* string config_path */ 2:
                    message.configPath = reader.string();
                    break;
                case /* google.protobuf.Duration cache_ttl */ 3:
                    message.cacheTtl = Duration.internalBinaryRead(reader, reader.uint32(), options, message.cacheTtl);
                    break;
                case /* repeated google.protobuf.Duration retry_backoff */ 4:
                    message.retryBackoff.push(Duration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 max_retries */ 5:
                    message.maxRetries = reader.int32();
                    break;
                case /* map<string, string> params */ 6:
                    this.binaryReadMap6(message.params, reader, options);
                    break;
                case /* agency.config.v1.CircuitBreakerConfig circuit_breaker */ 7:
                    message.circuitBreaker = CircuitBreakerConfig.internalBinaryRead(reader, reader.uint32(), options, message.circuitBreaker);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: CredentialConfig["params"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CredentialConfig["params"] | undefined, val: CredentialConfig["params"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.CredentialConfig.params");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: CredentialConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string provider = 1; */
        if (message.provider !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.provider);
        /* string config_path = 2; */
        if (message.configPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.configPath);
        /* google.protobuf.Duration cache_ttl = 3; */
        if (message.cacheTtl)
            Duration.internalBinaryWrite(message.cacheTtl, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Duration retry_backoff = 4; */
        for (let i = 0; i < message.retryBackoff.length; i++)
            Duration.internalBinaryWrite(message.retryBackoff[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 max_retries = 5; */
        if (message.maxRetries !== 0)
            writer.tag(5, WireType.Varint).int32(message.maxRetries);
        /* map<string, string> params = 6; */
        for (let k of globalThis.Object.keys(message.params))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.params[k]).join();
        /* agency.config.v1.CircuitBreakerConfig circuit_breaker = 7; */
        if (message.circuitBreaker)
            CircuitBreakerConfig.internalBinaryWrite(message.circuitBreaker, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.CredentialConfig
 */
export const CredentialConfig = new CredentialConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerCreateRequest$Type extends MessageType<ConsumerCreateRequest> {
    constructor() {
        super("agency.config.v1.ConsumerCreateRequest", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "policy", kind: "message", T: () => ConsumerPolicy, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "filter_subjects", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 5, name: "durable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 7, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerCreateRequest>): ConsumerCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.filterSubjects = [];
        message.durable = false;
        message.description = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ConsumerCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerCreateRequest): ConsumerCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* agency.policy.v1.ConsumerPolicy policy */ 3:
                    message.policy = ConsumerPolicy.internalBinaryRead(reader, reader.uint32(), options, message.policy);
                    break;
                case /* repeated string filter_subjects */ 4:
                    message.filterSubjects.push(reader.string());
                    break;
                case /* bool durable */ 5:
                    message.durable = reader.bool();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* map<string, string> metadata */ 7:
                    this.binaryReadMap7(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: ConsumerCreateRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConsumerCreateRequest["metadata"] | undefined, val: ConsumerCreateRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.ConsumerCreateRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ConsumerCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* agency.policy.v1.ConsumerPolicy policy = 3; */
        if (message.policy)
            ConsumerPolicy.internalBinaryWrite(message.policy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string filter_subjects = 4; */
        for (let i = 0; i < message.filterSubjects.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.filterSubjects[i]);
        /* bool durable = 5; */
        if (message.durable !== false)
            writer.tag(5, WireType.Varint).bool(message.durable);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* map<string, string> metadata = 7; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerCreateRequest
 */
export const ConsumerCreateRequest = new ConsumerCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerCreateResponse$Type extends MessageType<ConsumerCreateResponse> {
    constructor() {
        super("agency.config.v1.ConsumerCreateResponse", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerCreateResponse>): ConsumerCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.created = false;
        if (value !== undefined)
            reflectionMergePartial<ConsumerCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerCreateResponse): ConsumerCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* bool created */ 3:
                    message.created = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConsumerCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* bool created = 3; */
        if (message.created !== false)
            writer.tag(3, WireType.Varint).bool(message.created);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerCreateResponse
 */
export const ConsumerCreateResponse = new ConsumerCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerDeleteRequest$Type extends MessageType<ConsumerDeleteRequest> {
    constructor() {
        super("agency.config.v1.ConsumerDeleteRequest", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerDeleteRequest>): ConsumerDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        if (value !== undefined)
            reflectionMergePartial<ConsumerDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerDeleteRequest): ConsumerDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConsumerDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerDeleteRequest
 */
export const ConsumerDeleteRequest = new ConsumerDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerDeleteResponse$Type extends MessageType<ConsumerDeleteResponse> {
    constructor() {
        super("agency.config.v1.ConsumerDeleteResponse", [
            { no: 1, name: "deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerDeleteResponse>): ConsumerDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deleted = false;
        if (value !== undefined)
            reflectionMergePartial<ConsumerDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerDeleteResponse): ConsumerDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool deleted */ 1:
                    message.deleted = reader.bool();
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 2:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConsumerDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool deleted = 1; */
        if (message.deleted !== false)
            writer.tag(1, WireType.Varint).bool(message.deleted);
        /* google.protobuf.Timestamp deleted_at = 2; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerDeleteResponse
 */
export const ConsumerDeleteResponse = new ConsumerDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerInfoRequest$Type extends MessageType<ConsumerInfoRequest> {
    constructor() {
        super("agency.config.v1.ConsumerInfoRequest", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerInfoRequest>): ConsumerInfoRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        if (value !== undefined)
            reflectionMergePartial<ConsumerInfoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerInfoRequest): ConsumerInfoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConsumerInfoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerInfoRequest
 */
export const ConsumerInfoRequest = new ConsumerInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConsumerInfoResponse$Type extends MessageType<ConsumerInfoResponse> {
    constructor() {
        super("agency.config.v1.ConsumerInfoResponse", [
            { no: 1, name: "stream_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "consumer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "policy", kind: "message", T: () => ConsumerPolicy },
            { no: 4, name: "num_pending", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "num_ack_pending", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "num_redelivered", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "num_waiting", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ConsumerInfoResponse>): ConsumerInfoResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.streamName = "";
        message.consumerName = "";
        message.numPending = 0n;
        message.numAckPending = 0n;
        message.numRedelivered = 0n;
        message.numWaiting = 0n;
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ConsumerInfoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConsumerInfoResponse): ConsumerInfoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stream_name */ 1:
                    message.streamName = reader.string();
                    break;
                case /* string consumer_name */ 2:
                    message.consumerName = reader.string();
                    break;
                case /* agency.policy.v1.ConsumerPolicy policy */ 3:
                    message.policy = ConsumerPolicy.internalBinaryRead(reader, reader.uint32(), options, message.policy);
                    break;
                case /* uint64 num_pending */ 4:
                    message.numPending = reader.uint64().toBigInt();
                    break;
                case /* uint64 num_ack_pending */ 5:
                    message.numAckPending = reader.uint64().toBigInt();
                    break;
                case /* uint64 num_redelivered */ 6:
                    message.numRedelivered = reader.uint64().toBigInt();
                    break;
                case /* uint64 num_waiting */ 7:
                    message.numWaiting = reader.uint64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* map<string, string> metadata */ 9:
                    this.binaryReadMap9(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: ConsumerInfoResponse["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConsumerInfoResponse["metadata"] | undefined, val: ConsumerInfoResponse["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.config.v1.ConsumerInfoResponse.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ConsumerInfoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stream_name = 1; */
        if (message.streamName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.streamName);
        /* string consumer_name = 2; */
        if (message.consumerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.consumerName);
        /* agency.policy.v1.ConsumerPolicy policy = 3; */
        if (message.policy)
            ConsumerPolicy.internalBinaryWrite(message.policy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* uint64 num_pending = 4; */
        if (message.numPending !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.numPending);
        /* uint64 num_ack_pending = 5; */
        if (message.numAckPending !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.numAckPending);
        /* uint64 num_redelivered = 6; */
        if (message.numRedelivered !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.numRedelivered);
        /* uint64 num_waiting = 7; */
        if (message.numWaiting !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.numWaiting);
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 9; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.ConsumerInfoResponse
 */
export const ConsumerInfoResponse = new ConsumerInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IngressPolicyConfig$Type extends MessageType<IngressPolicyConfig> {
    constructor() {
        super("agency.config.v1.IngressPolicyConfig", [
            { no: 1, name: "max_queue_depth", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 1000, gt: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<IngressPolicyConfig>): IngressPolicyConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxQueueDepth = 0;
        if (value !== undefined)
            reflectionMergePartial<IngressPolicyConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IngressPolicyConfig): IngressPolicyConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 max_queue_depth */ 1:
                    message.maxQueueDepth = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IngressPolicyConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 max_queue_depth = 1; */
        if (message.maxQueueDepth !== 0)
            writer.tag(1, WireType.Varint).uint32(message.maxQueueDepth);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.config.v1.IngressPolicyConfig
 */
export const IngressPolicyConfig = new IngressPolicyConfig$Type();
